/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import React, {useState, useEffect, useRef} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import {getLayout, ILayout, LayoutSetup, useLayout} from '../../../_metronic/layout/core'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import {Link} from 'react-router-dom'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {useTranslation, initReactI18next} from 'react-i18next'
import {
  getSIPDetail,
  updateAmendment,
  getAccesses,
  resubmitSIP,
  getPOforSIP,
  getRegardingSIP,
} from '../../../api/modules/sip'
import AddRemoveJadwal from './AddRemoveJadwal'
import swal from 'sweetalert'
import {useNavigate, useParams} from 'react-router-dom'
import {getPlant} from '../../../api/modules/getdatalist'
import {editChildPlant} from '../../../api/modules/order'
import {PageTitle} from '../../../_metronic/layout/core'
import {useIntl} from 'react-intl'
import {create, getFile, deleteFile} from '../../../api/modules/file'
import {useDispatch, useSelector} from 'react-redux'
import {setGetNotif} from '../../../_metronic/redux/content'
import {Spinner} from 'react-bootstrap'
import i18next from 'i18next'
import InputGroup from 'react-bootstrap/InputGroup'
import DatePicker from 'react-datepicker'

import Editor from 'src/app/components/Editor'

import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Popover from 'react-bootstrap/Popover'
import Accordion from 'react-bootstrap/Accordion'
import './TextEditorZIndex.scss'
import CurrencyInput from 'react-currency-input-field'
import {PopoverText} from '../../../components/Popover/Popover'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {setPDFPreview, sipSelector} from '../../../redux/slices/sipSlices'
import {PDFPreviewModal} from './PDFPreviewModal'
import {ViewLetter} from '../../../components/Letter/ViewLetter'
import {getRoleFlagList} from '../../../api/modules/master-data/master_2'
import {MultiSelect} from 'react-multi-select-component'
import {PriceFormater} from '../../../components/mikro/PriceFormater'
import {authSelector} from 'src/redux/slices/authSlices'
import {HakAkses} from 'src/components/mikro/getHakAkses'
import {BadgeColorSIP} from 'src/components/BadgeColorSIP'
import {CheckSameIDAttachment} from 'src/components/mikro/CheckSameIDAttachment'
import {FindTodayDate_DDMMYY} from 'src/components/mikro/FindTodayDate_DDMMYY'
import Skeleton from 'react-loading-skeleton'
import dateformat from 'src/utils/dateformat'
import { AttachmentModal } from './AttachmentModal'
import { fetchHistorySIP } from 'src/services/fetcher'
import { TOrderSubDetail } from 'src/redux/types'
import { setOrderSubDetail } from 'src/redux/slices/appSlices'
import {CustomModal} from '../../../components/CustomModal'
import {FormDetailSIP} from './FormDetailSIP'
import { SIPHistories } from './SIPHistories'
import { SettingApproval } from './SettingApproval'

const SIPEdit: React.FC = () => {
  const intl = useIntl()
  const editorRef: any = useRef()
  const dispath = useDispatch()
  const notif = useSelector((state: any) => state.notif.getNotif)
  const appDispatch = useAppDispatch()
  const hakAkses = HakAkses()
  const {roleId} = useAppSelector(authSelector)
  const {pdfPreview} = useAppSelector(sipSelector)
  const {t} = useTranslation()
  const [btnLoading, setBtnLoading] = useState(false)

  //#region
  const [dataSIPDetail, setDataSIPDetail] = useState<any[]>([])
  const [sipNumber, setSIPNumber] = useState('')
  const [sipStatusText, setSIPStatusText] = useState('')
  const [sipStatus, setSIPStatus] = useState('')
  const [customer, setCustomer] = useState('')
  const [regarding, setRegarding] = useState('')
  const [perihalTanggal, setPerihalTanggal] = useState('')
  const [dateFrom, setDateFrom] = useState('')
  const [dateTo, setDateTo] = useState('')
  const [price, setPrice] = useState(0)
  const [quantum, setQuantum] = useState<any>()
  const [loading, setLoading] = useState(false)
  const [SIPNumberAttactment, setSIPNumberAttactment] = useState(null)
  const [signerNamer, setSignerName] = useState('')
  const [singerPosition, setSignerPositon] = useState('')
  const [kepada, setKepada] = useState('')
  const [lain, setLain] = useState('')
  const [initialLain, setInitialLain] = useState('')
  const [initialFooterContent, setInitialFooterContent] = useState(
    '<p>Selanjutnya, mengacu Surat Perjanjian Jasa Pemasaran No. 071/A/KU/G12/SP/2021 dan guna proses lebih lanjut terkait Penjualan Produk Non Subsidi Dalam Negeri & Ekspor, agar dapat melakukan proses penerbitan dokumen transaksi jual beli dengan pembeli tersebut pada kesempatan pertama</p>'
  )
  const [initialBodyContent, setInitialBodyContent] = useState(
    '<p>Menindaklanjuti hasil negosiasi yang telah dilakukan antara PT Pupuk Indonesia (Persero) dengan melalui surat ini kami informasikan poin-poin pokok hasil kesepakatan sebagai berikut:</p>'
  )
  const [footerContent, setFooterContent] = useState('<p>Selanjutnya, mengacu Surat Perjanjian Jasa Pemasaran No. 071/A/KU/G12/SP/2021 dan guna proses lebih lanjut terkait Penjualan Produk Non Subsidi Dalam Negeri & Ekspor, agar dapat melakukan proses penerbitan dokumen transaksi jual beli dengan pembeli tersebut pada kesempatan pertama</p>')
  const [bodyContent, setBodyContent] = useState('<p>Menindaklanjuti hasil negosiasi yang telah dilakukan antara PT Pupuk Indonesia (Persero) dengan melalui surat ini kami informasikan poin-poin pokok hasil kesepakatan sebagai berikut:</p>')
  const [tempArrayID, setTempArrayID] = useState<any[]>([])
  const [statusID, setStatusID] = useState(0)
  const [sektorID, setSektorID] = useState(0)
  const [detailOrder, setDetailOrder] = useState<any>({})
  const [showDetail, setShowDetail] = useState(false)
  const [showJadwal, setShowJadwal] = useState(false)
  const [allID, setAllID] = useState<any>([])
  const [custAccount, setCustAccount] = useState('')
  const [retailFlag, setRetailFlag] = useState('')
  const [approveFlag, setApproveFlag] = useState(false)
  const [accesses, setAccesses] = useState<any>()
  const [grandtotal, setGrandtotal] = useState(0)
  const [grandtotalUsd, setGrandtotalUsd] = useState(0)
  const [isAmandemend, setIsAmandemend] = useState(false)
  const [showLetter, setShowLetter] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingModal, setIsLoadingModal] = useState(false)
  //#endregion

  const navigate = useNavigate()
  const [roleUser, setRoleUser] = useState('')
  const [showAddItem, setShowAddItem] = useState(false)
  const [customerCode, setCustomerCode] = useState('')
  const [customerName, setCustomerName] = useState('')
  const [customerTitle, setCustomerTitle] = useState('')
  const [customerAddress, setCustomerAddress] = useState('')
  const [paymentMethod, setPaymentMethod] = useState('')
  const [param, setParam] = useState('')
  const [perihalTanggal2, setPerihalTanggal2] = useState<any>()
  const [dateFrom2, setDateFrom2] = useState<any>()
  const [dateTo2, setDateTo2] = useState<any>()
  const [IDOrder, setIDOrder] = useState(0)
  const [fullNewOrder, setFullNewOrder] = useState<any[]>([])
  const [allAddedID, setAllAddedID] = useState<any[]>([])
  const [showAddItemAmandemen, setShowAddItemAmandemen] = useState(false)
  const [grandtotal2, setGrandtotal2] = useState(0)
  const [grandtotal2usd, setGrandtotal2usd] = useState(0)
  const [quantum2, setQuantum2] = useState(0)
  const [addedNewItem, setAddedNewItem] = useState<any[]>([])
  const params = useParams()
  const [fileBox, setFileBox] = useState<any>({})
  const [fullPengajuanOrder, setFullPengajuanOrder] = useState<any>([])
  const [nomorSIP, setNomorSIP] = useState('')
  const [approvedDate, setApprovedDate] = useState('')
  const [itemEditing, setItemEditing] = useState<any>()
  const [dataSIP, setDataSIP] = useState<any>()
  const [attachmentType, setAttachmentType] = useState<any>('')
  const [regardingsSIP, setRegardingsSIP] = useState<any>([])
  const [regardingSIP, setRegardingSIP] = useState('')
  const [regardingSIPDesc, setRegardingSIPDesc] = useState('')
  const [revisi_count, setRevisi_count] = useState('')
  const [sipHistories, setSipHistories] = useState<any>([])
  const [allItems, setAllItems] = useState<any[]>([])
  const [reviewers, setReviewers] = useState<any[]>([])
  const [approvers, setApprovers] = useState<any[]>([])

  useEffect(() => {
    setAllItems([
      ...dataSIPDetail,
      ...addedNewItem
    ]);
  }, [dataSIPDetail, addedNewItem])

  const onChangeApprovers = (data: any[]) => {
    setApprovers(data)
  }
  const onChangeReviewers = (data: any[]) => {
    setReviewers(data)
  }
  
  const handlePDFFilterChange = (value: Partial<typeof pdfPreview>) => {
    appDispatch(setPDFPreview({...pdfPreview, ...value}))
  }

  const getSIP = async () => {
    setLoading(true)
    const res = await getSIPDetail(params.id, localStorage.getItem('credential'), 'true')

    if (!res.data.error) {
      if (localStorage.getItem('role-flag') === 'salesAnper') dispath(setGetNotif(!notif))

      if (!res.data?.data?.is_amendment) {
        setDataSIPDetail(res.data.data.order_sub_details.map((item: any) => ({
          ... item, 
          is_new_item: false,
          have_action: true
        })))
        setFullPengajuanOrder(res.data.data.pengajuan_order?.children.map((item: any) => ({
          ... item,
          is_new_item: true
        })))
        } else {
        setDataSIPDetail(res.data.data.order_sub_details)
        setFullPengajuanOrder(res.data.data.pengajuan_order?.children)
      }

      setDataSIP(res.data.data)
      // setRegardingSIP(res.data?.data?.sip_type)
      setRegardingSIPDesc(res.data?.data?.sip_type_desc)
      setRevisi_count(res.data?.data?.amendment_counting)
      setNomorSIP(res.data.data.SIP_number)
      setApprovedDate(res.data.data.approved_date ? res.data.data.approved_date : '') 
      setCustAccount(res.data.data.customer?.customer_account_group)
      setStatusID(res.data.data.status)
      setSIPNumber('10' + res.data.data.pengajuan_order.po_number)
      setSIPStatusText(res.data.data.status_text)
      setSIPStatus(res.data.data.status)
      setCustomer(res.data.data.customer?.title + ' ' + res.data.data.customer?.name)
      setRegarding(res.data.data.pengajuan_order.regarding)
      setPerihalTanggal(res.data.data.estimate_date)
      setDateFrom(res.data.data.valid_date_from)
      setDateTo(res.data.data.valid_date_to)
      setDateTo2(new Date(res.data.data.valid_date_to))
      setDateFrom2(new Date(res.data.data.valid_date_from))
      setPerihalTanggal2(new Date(res.data.data.estimate_date))
      setSektorID(res.data.data.sector_id)
      setSignerName(res.data.data.signer_name)
      setSignerPositon(res.data.data.signer_position)
      setKepada(res.data.data.kepada)
      setLain(res.data.data.lain_lain)
      setIsAmandemend(res.data.data.is_amendment)
      setInitialLain(res.data.data.lain_lain)
      setLain(res.data.data.lain_lain)
      setInitialBodyContent(res.data.data.body_content)
      setBodyContent(res.data.data.body_content)
      setInitialFooterContent(res.data.data.footer_content)
      setFooterContent(res.data.data.footer_content)
      if (res.data.data.is_amendment) {
        let res2 = await getPOforSIP(res.data.data.order_sub_id, localStorage.getItem('credential'))
        const dataRegardingsSIP = await getRegardingSIP()
        const dataSIPHistories = await fetchHistorySIP(res.data.data.id, {is_amandment: true})
        setFullNewOrder(res2.data.data.children)
        setRegardingsSIP(dataRegardingsSIP?.data?.data)
        setSipHistories(dataSIPHistories.data?.data)
      }
      setIDOrder(res.data.data.order_sub_id)
      // console.log(res.data.data.sector_id)
      setRetailFlag(res.data.data.customer?.customer_account_group)
      let temptotal = 0
      let temptotalusd = 0
      let temptotalquantum = 0
      let temparray: any[] = []
      res.data.data.order_sub_details?.forEach((value: any) => {
        temparray.push(value.id)
        temptotal = temptotal + parseFloat(value?.fixed_price) * parseFloat(value?.fixed_quantum)
        temptotalusd = temptotalusd + parseFloat(value?.price_usd) * parseFloat(value?.fixed_quantum)
        temptotalquantum += value?.fixed_quantum
      })
      setAllID(temparray)
      setGrandtotal(temptotal)
      setGrandtotalUsd(temptotalusd)
      setPrice(res.data.data.price)
      setQuantum(temptotalquantum)
      // console.log(res.data.data.total_quantum)
      setApproveFlag(res.data.data.show_btn_approve)
      setCustomerCode(res.data.data.customer?.customer_code)
      setCustomerName(res.data.data.customer?.name)
      setCustomerTitle(res.data.data.customer?.title ? res.data.data.customer?.title : '')
      setCustomerAddress(res.data.data.customer?.address)
      setPaymentMethod(res.data.data.payment_method_info)
      setReviewers(res.data.data.sip_reviewers?.map((item: any) => {
        return {
          label: [
            item?.username,
            item?.name,
          ].join(" - "),
          value: item?.user_id
        }
      }))
      setApprovers(res.data.data.sip_approvers?.map((item: any) => {
        return {
          label: [
            item?.username,
            item?.name,
          ].join(" - "),
          value: item?.user_id
        }
      }))

      handlePDFFilterChange({
        address: res.data.data.customer?.address ?? '',
        payment_method: res.data.data.payment_method_info ?? '',
        customer_code: res.data.data.customer?.customer_code ?? '',
        customer_name: res.data.data.customer?.name ?? '',
        regarding: res.data.data.pengajuan_order.regarding ?? '',
        sip_number: res.data.data.SIP_number ?? '',
        description: res.data.data.lain_lain ?? '',
        from_date: res.data.data.valid_date_from ?? '',
        receiver_name: res.data.data.kepada ?? '',
        sector_id: res.data.data.sector_id ?? '',
        signer_name: res.data.data.signer_name ?? '',
        signer_position: res.data.data.signer_position ?? '',
        submission_date: res.data.data.estimate_date ?? '',
        to_date: res.data.data.valid_date_to ?? '',
        items: res.data.data.order_sub_details,
      })
    }
    setLoading(false)
  }

  const lang = i18next.language

  const handleshowjadwal = () => {
    // const getData = setTimeout(async () => {
    //   setShowJadwal(true)
    // }, 2000)

    // return () => clearTimeout(getData)
    setShowJadwal(true)
  }

  useEffect(() => {
    const role = () => {
      const role: any = localStorage.getItem('role-flag')
      setRoleUser(role)
    }

    const getAccessMenu = async () => {
      setLoading(true)
      const res = await getAccesses(roleId)
      setAccesses(res.data.data)
    }

    getAccessMenu()
    role()
    getSIP()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const [showUpload, setShowUpload] = useState(false)
  const [allFiles, setAllFiles] = useState<any[]>([])
  const [files, setFiles] = useState({file: null})
  const [namaFile, setNamaFile] = useState('')
  const [description, setDescription] = useState('')
  const [isPrivate, setIsPrivate] = useState(false)
  const [dataType, setDataType] = useState('')
  const [subOrderID, setSubOrderID] = useState('')
  const [provinceName, setProvinceName] = useState('')
  const [cityName, setCityName] = useState('')
  const [productName, setProductName] = useState('')
  const [requestQuantum, setReqeustQuantum] = useState('')
  const [fixedQuantum, setFixedQuantum] = useState('')
  const [idSektor, setIDSector] = useState(0)

  function formattingdate(date: any) {
    let arraydate: any[] = date.split('-')
    let tempdate = arraydate[2] + '-' + arraydate[1] + '-' + arraydate[0] + ' 00:00:00'
    let newdate = new Date(tempdate)
    return newdate
  }

  const formattingTon = (ton: any) => {
    let tempTon = parseFloat(ton)
    let temp = ''
    if (i18next.language == 'en') {
      temp = tempTon.toLocaleString('en', {maximumFractionDigits: 4})
    } else {
      temp = tempTon.toLocaleString('id', {maximumFractionDigits: 4})
    }
    setFixedQuantum(temp)
  }

  const ambilAttachment = async (id: any) => {
    let temp = 'order-item'
    if (param == 'sip') temp = 'sip'
    else temp = 'order-item'
    await getFile(temp, id, localStorage.getItem('credential')!).then((res) => {
      setAllFiles(res.data.data)
      setIsLoadingModal(false)
    })
  }

  const handleShowAttachment = (data: any) => {
    let tmp: any[] = []
    let idUser = localStorage?.getItem('user-id')
    data.forEach((item: any) => {
      if (item.private) {
        if (accesses?.attachment) {
          return tmp.push(item)
        } else if (idUser == item.user_id) {
          return tmp.push(item)
        } else {
        }
      } else {
        return tmp.push(item)
      }
    })
    setAllFiles(tmp)
  }

  const clearFile = () => {
    const inputfile = document.getElementById('upload') as HTMLInputElement
    inputfile.value = ''
    const inputPrivate = document.getElementById('isPrivate') as HTMLInputElement
    inputPrivate.checked = false
  }

  const deleteAttachment = async (id: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Yes')}`],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        await deleteFile(id)
          .then(() => {
            swal({
              closeOnClickOutside: false,
              title: t('Dokumen Berhasil Dihapus'),
              icon: 'success',
            })
            ambilAttachment(subOrderID)
          })
          .catch((error) => {
            swal({
              title: error.response.data,
              icon: 'error',
            })
          })
      }
    })
  }

  const dateFormatting = (date: any) => {
    if (date == null) return ''
    else {
      let today = new Date(date)
      let dd = String(today.getDate()).padStart(2, '0')
      let mm = String(today.getMonth() + 1).padStart(2, '0') //January is 0!
      let yyyy = today.getFullYear()
      return dd + '-' + mm + '-' + yyyy
    }
  }

  const updateAmandemen = async () => {
    swal({
      title: `${t('apakahAndaYakin')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then(async (accept) => {
      setIsLoading(true)
      let tempallids: any[] = [...allID]
      try {
        if (allAddedID.length > 0) {
          allAddedID.forEach((element) => {
            tempallids.push(element)
          })
        }
        if (accept) {
          let temparray: any[] = []
          if (addedNewItem.length > 0) {
            addedNewItem.forEach((data: any) => {
              temparray.push({
                id: data.id,
                is_formulated_price: data.is_formulated_price,
                fixed_price: data.fixed_price,
              })
            })
          }

          let payload = {
            id_pengajuan_order: IDOrder,
            customer: customerCode,
            perihal: regarding,
            estimate_date: perihalTanggal,
            valid_date_from: dateFrom,
            valid_date_to: dateTo,
            order_sub_detail_id: tempallids,
            lang: i18next.language,
            lain_lain: lain,
            body_content: bodyContent,
            footer_content: footerContent,
            kepada: kepada,
            signer_name: signerNamer,
            signer_position: singerPosition,
            payment_method_info: paymentMethod,
            new_items: temparray,
            sip_type: regardingSIP,
            reviewer_ids: reviewers?.map((item: any) => item.value),
            approver_ids: approvers?.map((item: any) => item.value)
          }

          setBtnLoading(true)
          await updateAmendment(params.id, payload)
            .then((res) => {
              if (!res.data.error) {
                swal({
                  title: `${t('Harga Berhasil Diperbarui')}`,
                  icon: 'success',
                }).then(() => {
                  dispath(setGetNotif(!notif))
                  navigate('/management/si/all')
                })
              } else
                swal({
                  title: `${res.data}`,
                  icon: 'error',
                })
            })
            .catch(function (error) {
              if (error.response) {
                swal({
                  title: `${error.response.data.message}`,
                  icon: 'error',
                })
              }
            })
            .finally(() => {
              setBtnLoading(false)
            })
        }
      } catch {
        setIsLoading(false)
      }
    })
    .finally(() => setIsLoading(false))
  }

  const submitEditSIP = async () => {
    swal({
      title: `${t('apakahAndaYakin')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    })
    .then(async (accept) => {
      setIsLoading(true)
      try {
        if (accept) {
          let tempids: any[] = []
          dataSIPDetail.forEach((data: any) => {
            tempids.push(data.is_new_item ? data.id : data.order_sub_item_id)
          })
          let payload = {
            id_pengajuan_order: IDOrder,
            customer: customerCode,
            perihal: regarding,
            estimate_date: perihalTanggal,
            valid_date_from: dateFrom,
            valid_date_to: dateTo,
            order_sub_detail_id: tempids,
            lang: i18next.language,
            lain_lain: lain,
            body_content: bodyContent,
            footer_content: footerContent,
            kepada: kepada,
            signer_name: signerNamer,
            signer_position: singerPosition,
            payment_method_info: paymentMethod,
            reviewer_ids: reviewers?.map((item: any) => item.value),
            approver_ids: approvers?.map((item: any) => item.value)
          }

          setBtnLoading(true)
          await resubmitSIP(params.id, payload)
            .then((res) => {
              if (!res.data.error) {
                swal({
                  title: `${t('Harga Berhasil Diperbarui')}`,
                  icon: 'success',
                }).then(() => {
                  dispath(setGetNotif(!notif))
                  navigate('/management/si/all')
                })
              } else
                swal({
                  title: `${res.data}`,
                  icon: 'error',
                })
            })
            .catch(function (error) {
              if (error.response) {
                swal({
                  title: `${error.response.data.message}`,
                  icon: 'error',
                })
              }
            })
            .finally(() => {
              setBtnLoading(false)
            })
        }
      } catch {
        setIsLoading(false)
      }
    })
    .finally(() => {
      setIsLoading(false)
    })
  }

  const removeSubOrder = (index: any) => {
    swal({
      title: `${t('apakahAndaYakin')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then((accept) => {
      if (accept) {
        const temp: any = [...dataSIPDetail]
        const temp2: any[] = [...allID]
        const tempIndex = temp2.indexOf(temp[index].id)

        setFullPengajuanOrder([...fullPengajuanOrder, temp[index]])

        let temptotal = 0
        let temptotalusd = 0
        let tempkuantum = 0

        temp2.splice(tempIndex, 1)
        temp.splice(index, 1)

        if (temp.length > 0) {
          temp.forEach((data: any, _index: any) => {
            if (temp2.indexOf(data.id) != -1) {
              tempkuantum = tempkuantum + parseFloat(data?.fixed_quantum)
              temptotal =
                temptotal + parseFloat(data?.fixed_price) * parseFloat(data?.fixed_quantum)
              temptotalusd =
                temptotalusd + parseFloat(data?.price_usd) * parseFloat(data?.fixed_quantum)
            }
          })
        }

        setDataSIPDetail(temp)
        setAllID(temp2)
        setGrandtotal(temptotal)
        setGrandtotalUsd(temptotalusd)
        setQuantum(tempkuantum)
      }
    })
  }

  const onclickCheckBox = (id: any) => {
    const isChecked = document.getElementById(`checkbox${id}`) as HTMLInputElement
    const tempArray: any[] = tempArrayID
    let temp = parseInt(isChecked.value)
    if (isChecked.checked) {
      tempArray.push(temp)
    } else {
      const tempindex = tempArray.indexOf(temp)
      tempArray.splice(tempindex, 1)
    }
    setTempArrayID(tempArray)
  }

  const addInOrder = (type: any) => {
    
    const tempArray: any[] = allID
    let tempPrice = 0
    let tempPriceusd = 0
    let tempQuantum = 0
    let grandtot = 0

    if (tempArrayID.length < 1) {
      return swal({
        title: `${t('item tidak boleh kosong')}`,
        icon: 'error',
      })
    }

    tempArrayID.forEach((value: any, index: any) => tempArray.push(value))

    const sipItems = [
      ... dataSIPDetail,
      ... fullPengajuanOrder.filter((item: any) => tempArrayID.includes(item.id))
    ]

    setDataSIPDetail(sipItems)
    setFullPengajuanOrder(fullPengajuanOrder.filter((item: any) => !tempArrayID.includes(item.id)))
    
    sipItems.forEach((data: any, _index: any) => {
      if (allID.indexOf(data.id) != -1) {
        tempQuantum = tempQuantum + parseFloat(data?.fixed_quantum)
        tempPrice = tempPrice + parseFloat(data?.fixed_price) * parseFloat(data?.fixed_quantum)
        tempPriceusd = tempPriceusd + parseFloat(data?.price_usd) * parseFloat(data?.fixed_quantum)
      }
    })

    setGrandtotal(tempPrice)
    setGrandtotalUsd(tempPriceusd)
    setQuantum(tempQuantum)
    setShowAddItem(false)

  }

  const addInOrder2 = () => {
    const tempArray: any[] = [...allAddedID]
    const tempArray2: any[] = [...addedNewItem]
    let tempPrice = 0
    let tempPriceusd = 0
    let tempQuantum = 0
    let grandtot = 0

    if (tempArrayID.length < 1) {
      swal({
        title: `${t('item tidak boleh kosong')}`,
        icon: 'error',
      })
    } else {
      tempArrayID.forEach((value: any, index: any) => {
        tempArray.push(value)
      })
    }

    // console.log(tempArray)

    // fullNewOrder.forEach((data : any, _index : any) => {
    //   if(allAddedID.indexOf(data.id) != -1){
    //     tempQuantum = tempQuantum + parseFloat(data?.fixed_quantum)
    //     tempPrice = tempPrice + Math.round(parseInt(data?.fixed_price) * parseFloat(data?.fixed_quantum))
    //   }
    // });
    fullNewOrder.forEach((data: any, index: any) => {
      const hargap = document.getElementById('hargap' + data.id) as HTMLInputElement
      const isChecked = document.getElementById(`checkbox${data.id}`) as HTMLInputElement
      if (isChecked.checked == true) {
        let tempobject: any = data
        if (data.is_formulated_price && hargap != null) {
          let tempharga = hargap.value
          // console.log(tempharga)
          tempharga = tempharga.replaceAll('.', '')
          // console.log(tempharga)
          tempharga = tempharga.replaceAll(',', '')
          tempobject.fixed_price = parseFloat(tempharga)
          tempQuantum = tempQuantum + parseFloat(data?.fixed_quantum)
          tempPrice =
            tempPrice + parseFloat(tempobject?.fixed_price) * parseFloat(data?.fixed_quantum)
          tempPriceusd =
            tempPriceusd + parseFloat(tempobject?.price_usd) * parseFloat(data?.fixed_quantum)
        } else {
          tempQuantum = tempQuantum + parseFloat(data?.fixed_quantum)
          tempPrice = tempPrice + parseFloat(data?.fixed_price) * parseFloat(data?.fixed_quantum)
          tempPriceusd = tempPriceusd + parseFloat(data?.price_usd) * parseFloat(data?.fixed_quantum)
        }
        tempArray2.push(tempobject)
      }
    })

    setAllAddedID(tempArray)
    setAddedNewItem(tempArray2)
    setGrandtotal2(tempPrice)
    setGrandtotal2usd(tempPriceusd)
    setQuantum2(tempQuantum)
    setShowAddItemAmandemen(false)

    handlePDFFilterChange({items: tempArray2})
    // console.log(addedOrder, ' addedOrder', tempPrice, ' tempprice ', tempQuantum, ' tempquantum')
  }

  const removeSubOrder2 = (index: any) => {
    swal({
      title: `${t('apakahAndaYakin')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then((accept) => {
      if (accept) {
        const temp: any = [...fullNewOrder]
        const temp2: any[] = [...allAddedID]
        const temp3: any[] = [...addedNewItem]
        const tempIndex = temp2.indexOf(temp[index].id)
        // console.log(temp, temp2)
        let temptotal = 0
        let temptotalusd = 0
        let tempkuantum = 0
        temp2.splice(tempIndex, 1)
        temp3.splice(tempIndex, 1)
        temp.forEach((data: any, _index: any) => {
          tempkuantum = tempkuantum + parseFloat(data?.fixed_quantum)
          temptotal = temptotal + parseFloat(data?.fixed_price) * parseFloat(data?.fixed_quantum)
          temptotalusd = temptotalusd + parseFloat(data?.price_usd) * parseFloat(data?.fixed_quantum)
        })

        if (temp3.length > 0) {
          temp3.forEach((data: any, _index: any) => {
            tempkuantum = tempkuantum + parseFloat(data?.fixed_quantum)
            temptotal = temptotal + parseFloat(data?.fixed_price) * parseFloat(data?.fixed_quantum)
            temptotalusd = temptotalusd + parseFloat(data?.price_usd) * parseFloat(data?.fixed_quantum)
          })
        }
        setAllAddedID(temp2)
        setAddedNewItem(temp3)
        setGrandtotal2(temptotal)
        setGrandtotal2usd(temptotalusd)
        setQuantum2(tempkuantum)
        handlePDFFilterChange({items: temp3})
      }
    })
  }

  const handleUpload = async () => {
    setBtnLoading(true)
    let file = files.file
    let formdata = new FormData()
    formdata.append('file_r', file!)
    formdata.append('name', namaFile!)
    formdata.append('description', description!)
    formdata.append('attach_parent', subOrderID)
    formdata.append('file_type', dataType)
    formdata.append('private', isPrivate.toString())
    if (SIPNumberAttactment) {
      formdata.append('unique_number', SIPNumberAttactment)
      formdata.append('unique_flag', 'new_sip_osd')
    }
    formdata.append('credentials', localStorage.getItem('credential')!)
    // console.log(formdata)
    await create('order-item', formdata)
      .then((res) => {
        swal({
          title: `${t('document uploaded successfully')}`,
          icon: 'success',
        }).then(() => {
          setNamaFile('')
          setDescription('')
          setDataType('')
          setIsPrivate(false)
          setFiles({file: null})
          clearFile()
        })
        ambilAttachment(subOrderID)
      })
      .catch(function (error) {
        swal({
          title: t(error.response.data.message),
          icon: 'error',
        })
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const handleShowEndUser = (enduser: any) => {
    let temparray: any[] = enduser.split(',')
    let temp = ''
    temparray.forEach((element: any, index: any) => {
      if (index + 1 == temparray.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return <label>{temp}</label>
  }

  const handleShowValue = (enduser: any) => {
    let temparray: any[] = enduser.split(',')
    let temp = ''
    temparray.forEach((element: any, index: any) => {
      if (index + 1 == temparray.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return temp
  }

  const removeStorage = () => {
    localStorage.removeItem('credential')
    localStorage.removeItem('credential-decoded')
    localStorage.removeItem('cust-code')
    sessionStorage.removeItem('id')
    sessionStorage.removeItem('po')
    localStorage.removeItem('token')
    localStorage.removeItem('role-flag')
    localStorage.removeItem('dist')
    localStorage.removeItem('cust-group')
    sessionStorage.removeItem('SI_ID')
    localStorage.removeItem('namaUser')
    localStorage.removeItem('username')
    localStorage.removeItem('name')
    localStorage.removeItem('access')
    localStorage.removeItem('accesses')
    localStorage.removeItem('cust-grup')
    localStorage.removeItem('email')
    sessionStorage.removeItem('kid')
    sessionStorage.removeItem('order-detail-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sip')
    localStorage.removeItem('user-id')
    localStorage.removeItem('token')
    sessionStorage.removeItem('amandemen')
    localStorage.removeItem('cus-grup')
    localStorage.removeItem('idNews')
    sessionStorage.removeItem('jbp')
    sessionStorage.removeItem('jbp-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sales-organization')
  }

  function convertDatePicker(date: any) {
    let dd = String(date.getDate()).padStart(2, '0')
    let mm = String(date.getMonth() + 1).padStart(2, '0')
    let yyyy = String(date.getFullYear())
    return yyyy + '-' + mm + '-' + dd
  }

  const [letterData, setletterData] = useState<any>({})

  function handleShowRoleName(role: any) {
    let temp = ''
    role.forEach((element: any, index: any) => {
      if (index + 1 == role.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return temp
  }

  const handleShowPreviewSIP = () => {
    let tempcombined: any[] = []
    let fullcustomer = customerName
    dataSIPDetail.forEach((element) => {
      tempcombined.push(element)
    })
    if (addedNewItem.length > 0) {
      addedNewItem.forEach((element) => {
        // console.log(element, 'element')
        tempcombined.push(element)
      })
    }

    if (customerTitle != '' && customerTitle != null)
      fullcustomer = customerTitle + ' ' + customerName

    setletterData({
      kepada: kepada,
      produsen: dataSIPDetail[0]?.produsen?.name,
      customer: fullcustomer,
      subItem: tempcombined,
      dateFrom: dateFrom,
      dateTo: dateTo,
      includePpn: dataSIPDetail[0]?.include_ppn,
      paymentInfo: paymentMethod,
      paymentMethod: tempcombined,
      lainlain: lain,
      signername: signerNamer,
      singerposition: singerPosition,
      sector: sektorID,
      tanggalApprove: FindTodayDate_DDMMYY(approvedDate),
      noSIP: nomorSIP,
      tipePembayaranSIP: paymentMethod ? paymentMethod : '',
      footerContent: footerContent ? footerContent : '',
      bodyContent: bodyContent ? bodyContent : '',
      regardingSIP: regardingSIP,
      regardingSIPDesc: regardingSIPDesc,
      revisi_count: revisi_count,
    })
    setShowLetter(true)
  }

  const regardingSIPChanged = (value: string) => {
    if (value) {
      const dataValue = value.split('~#~')
      getLatestSIP(dataValue[0])
      setRegardingSIP(dataValue[0])
      setRegardingSIPDesc(dataValue[1] + (sektorID == 3 ? ' Ekspor' : ' Dalam Negeri'))
    } else {
      getLatestSIP(dataSIP?.sip_type)
      setRegardingSIP('')
      setRegardingSIPDesc(dataSIP?.sip_type_desc)
      setRevisi_count(dataSIP?.amendment_counting)
    }
  }

  const getLatestSIP = (sip_type_selected: string) => {
    const dataSIP = [
      {
        id: sipHistories?.id,
        sip_type: sipHistories?.sip_type,
        amendment_counting: sipHistories?.amendment_counting
      },
      ... sipHistories?.history_sip_amendment.map((sip: any) => {
        return {
          id: sip?.id,
          sip_type: sip?.sip_type,
          amendment_counting: sip?.amendment_counting
        }
      })
    ].filter((item: any) => item.sip_type == sip_type_selected);
    
    dataSIP.sort((a, b) => {
      return b.amendment_counting - a.amendment_counting;
    });

    setRevisi_count((dataSIP[0]?.amendment_counting ?? 0) + 1)

  }

  const handleShowOrderDetail = (data: TOrderSubDetail) => {
    appDispatch(setOrderSubDetail(data))
    setDetailOrder(data)
    setShowDetail(true)
  }

  const [showModalHistory, setShowModalHistory] = useState(false)

  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: `${t('page Edit sip')}`})}</PageTitle>
      <div className='card'>
        <div className='card-body'>
          <Row>
            <Col md={6}>
              <Row className='mb-3'>
                <Col md={5}>
                  <p className='fs-4 mt-2'>
                    {t('sip-pengajuan')} {t('Order')}{' '}
                  </p>
                </Col>
                <Col md={7}>
                  <Form.Control type='text' defaultValue={sipNumber} disabled size='sm' />
                </Col>
              </Row>

              <Row className='mb-3'>
                <Col md={5}>
                  <p className='fs-4 mt-2'>{t('order-perihal')}</p>
                </Col>
                <Col md={7}>
                  <Form.Control
                    placeholder={t('order-perihal')}
                    aria-label='Default select example'
                    size='sm'
                    value={regarding == 'PO001' ? t('penjualan') : t('Non-penjualan')}
                    disabled
                  />
                </Col>
              </Row>

              <Row className='mb-3'>
                <Col md={5}>
                  <p className='fs-4 mt-2'>
                    {t('Assigner Name')}
                    <span className='text-danger' hidden={sektorID != 2 ? false : true}>
                      *
                    </span>
                  </p>
                </Col>
                <Col md={7}>
                  <Form.Control
                    size='sm'
                    id='assname'
                    placeholder={t('Assigner Name')}
                    value={signerNamer}
                    onChange={(e: any) => {
                      const value = e.target.value ?? ''
                      setSignerName(value)
                      handlePDFFilterChange({signer_name: value})
                    }}
                  />
                </Col>
              </Row>

              <Row className='mb-3'>
                <Col md={5}>
                  <p className='fs-4 mt-2'>{t('Start-Date')}</p>
                </Col>
                <Col md={7}>
                  <DatePicker
                    className='form-control'
                    selected={dateFrom2}
                    onChange={(date: any) => {
                      setDateFrom2(date)
                      setDateFrom(date ? convertDatePicker(new Date(date)) : '')
                      handlePDFFilterChange({from_date: (date as string) ?? ''})
                    }}
                    dateFormat='dd/MM/yyyy'
                  />
                </Col>
              </Row>

              <Row className='mb-3'>
                <Col md={5} className='d-flex align-items-center'>
                  <p className='fs-4'>{t('Tanggal Pengajuan SIP')}</p>
                </Col>
                <Col md={7}>
                  <DatePicker
                    className='form-control'
                    selected={perihalTanggal2}
                    onChange={(date: any) => {
                      setPerihalTanggal2(date)
                      setPerihalTanggal(date ? convertDatePicker(new Date(date)) : '')
                      handlePDFFilterChange({submission_date: (date as string) ?? ''})
                    }}
                    dateFormat='dd/MM/yyyy'
                  />
                  {/* <Form.Control
                    type='text'
                    placeholder={t('Tanggal Pengajuan SIP')}
                    defaultValue={perihalTanggal?.slice(0, 10)}
                    disabled
                    size='sm'
                  /> */}
                </Col>
              </Row>
              <Row className='mb-3'>
                <Col md={5}>
                  <p className='fs-4 mt-2'>
                    {t('kepada')}
                    <span className='text-danger' hidden={sektorID != 2 ? false : true}>
                      *
                    </span>
                  </p>
                </Col>
                <Col md={7}>
                  <Form.Control
                    size='sm'
                    id='kepada'
                    placeholder={t('kepada')}
                    value={kepada}
                    onChange={(e: any) => {
                      const value = e.target.value ?? ''
                      setKepada(value)
                      handlePDFFilterChange({receiver_name: value})
                    }}
                  />
                </Col>
              </Row>
                {isAmandemend && (
                  <Row className='mb-3'>
                    <Col md={5}>
                      <p className='fs-4 mt-2'>
                        {t('Regarding SIP')}
                        <span className='text-danger' hidden={sektorID != 2 ? false : true}>
                          *
                        </span>
                      </p>
                    </Col>
                    <Col md={7}>
                      <Form.Select aria-label='Default select example' size='sm' onChange={(e: any) => regardingSIPChanged(e.target.value)}>
                        <option value=''>{t('Choose')+ ' ' +t('Regarding SIP')}</option>
                        {regardingsSIP.map((item: any) => {
                          return (
                            <>
                              <option value={`${item?.code}~#~${item?.name}`}>{item?.name}</option>
                            </>
                          )
                        })}
                      </Form.Select>
                    </Col>
                  </Row>
                )}
            </Col>
            <Col md={6}>
              <Row className='mb-3'>
                <Col md={5}>
                  <p className='fs-4 mt-2'>{t('Customer Number')}</p>
                </Col>
                <Col md={7}>
                  <Form.Control
                    type='text'
                    value={customerCode}
                    placeholder={t('Customer Number')}
                    disabled
                    size='sm'
                  />
                </Col>
              </Row>
              <Row className='mb-3'>
                <Col md={5}>
                  <p className='fs-4 mt-2'>{t('Customer Name')}</p>
                </Col>
                <Col md={7}>
                  <Form.Control
                    type='text'
                    value={customerName}
                    placeholder={t('Customer Name')}
                    disabled
                    size='sm'
                  />
                </Col>
              </Row>
              <Row className='mb-3'>
                <Col md={5}>
                  <p className='fs-4 mt-2'>
                    {t('Assigner Position')}
                    <span className='text-danger' hidden={sektorID != 2 ? false : true}>
                      *
                    </span>
                  </p>
                </Col>
                <Col md={7}>
                  <Form.Control
                    id='asspos'
                    size='sm'
                    placeholder={t('Assigner Position')}
                    value={singerPosition}
                    onChange={(e: any) => {
                      const value = e.target.value ?? ''
                      setSignerPositon(value)
                      handlePDFFilterChange({signer_position: value})
                    }}
                  />
                </Col>
              </Row>
              <Row className='mb-3'>
                <Col md={5}>
                  <p className='fs-4 mt-2'>{t('End-Date')}</p>
                </Col>
                <Col md={7}>
                  <DatePicker
                    className='form-control'
                    selected={dateTo2}
                    onChange={(date: any) => {
                      setDateTo2(date)
                      setDateTo(date ? convertDatePicker(new Date(date)) : '')
                      handlePDFFilterChange({to_date: (date as string) ?? ''})
                    }}
                    dateFormat='dd/MM/yyyy'
                  />
                  {/* <Form.Control
                    type='text'
                    placeholder={t('End-Date')}
                    defaultValue={dateFormatting(dateTo)}
                    disabled
                    size='sm'
                  /> */}
                </Col>
              </Row>
              <Row className='mb-3'>
                <Col md={5} className='d-flex align-items-center'>
                  <p className='fs-4'>{t('Metode Pembayaran')}</p>
                </Col>
                <Col md={7}>
                  <Form.Control
                    as='textarea'
                    style={{height: '40px'}}
                    value={paymentMethod}
                    onChange={(e: any) => {
                      const value = e.target.value ?? ''
                      setPaymentMethod(value)
                      handlePDFFilterChange({payment_method: value})
                    }}
                    placeholder={t('Metode Pembayaran')}
                    size='sm'
                  />
                </Col>
              </Row>
              <Row className='mb-3'>
                <Col md={5}>
                  <p className='fs-4 mt-2'>{t('Address')}</p>
                </Col>
                <Col md={7}>
                  <Form.Control
                    as='textarea'
                    value={customerAddress}
                    placeholder={t('Address')}
                    disabled
                    size='sm'
                  />
                </Col>
              </Row>
            </Col>
          </Row>

          <Form.Group className='mb-10' controlId='formBasicPassword'>
            <p className='fs-4 mt-2'>Body</p>
            <Editor
                  data={bodyContent}
                  onChange={ ( content ) => {
                      setBodyContent(content)
                  }}
              />
          </Form.Group>

          <Form.Group className='mb-10' controlId='formBasicPassword'>
            <p className='fs-4 mt-2'>{t('Lain-lain')}</p>
            <Editor
                  data={lain}
                  onChange={ ( content ) => {
                      setLain(content)
                      handlePDFFilterChange({description: content})
                  }}
              />
          </Form.Group>

          <Form.Group className='mb-10' controlId='formBasicPassword'>
            <p className='fs-4 mt-2'>Footer</p>
            <Editor
                  data={footerContent}
                  onChange={ ( content ) => {
                      setFooterContent(content)
                  }}
              />
          </Form.Group>

          <hr />

          <div className='card-toolbar mt-10 d-flex justify-content-end'>
            <Button
              onClick={() => {
                setShowUpload(true)
                setItemEditing(dataSIP)
                setAttachmentType('sip')
              }}
              className='btn btn-primary fw-semibold d-flex align-items-center me-2'
              data-bs-toggle='tooltip'
              data-bs-placement='top'
              data-bs-trigger='hover'
              title={t('order-lampiran')}
            >
              <p>{t('order-lampiran')}</p>
            </Button>

            <Button className='fw-semibold me-2' onClick={() => handleShowPreviewSIP()}>
              {t('preview')}
            </Button>

            {!isAmandemend && fullPengajuanOrder.length > 0 && hakAkses?.update && (
              <Button
                onClick={() => {
                  setTempArrayID([])
                  setShowAddItem(true)
                }}
                className='btn btn-primary fw-semibold d-flex align-items-center'
                data-bs-toggle='tooltip'
                data-bs-placement='top'
                data-bs-trigger='hover'
                title={t('kontrak-tambah') + ' Item'}
                // data-bs-toggle='modal'
                // data-bs-target='#kt_modal_invite_friends'
              >
                <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                <p>{t('order-tambah')}</p>
              </Button>
            )}
            {isAmandemend && allAddedID.length != fullNewOrder.length && hakAkses?.update && (
              <Button
                onClick={() => {
                  setTempArrayID([])
                  setShowAddItemAmandemen(true)
                }}
                className='btn btn-primary fw-semibold d-flex align-items-center'
                data-bs-toggle='tooltip'
                data-bs-placement='top'
                data-bs-trigger='hover'
                title={t('kontrak-tambah') + ' Item'}
                // data-bs-toggle='modal'
                // data-bs-target='#kt_modal_invite_friends'
              >
                <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                <p>{t('order-tambah')}</p>
              </Button>
            )}

            <Button
              variant='primary'
              className='ms-2'
              title={t('history-sip-amendment')}
              onClick={() => {
                setShowModalHistory(true)
              }}
            >
              <KTSVG
                path='/media/icons/duotune/file-earmark-arrow-down-fill.svg'
                className='svg-icon-3'
              />
              {t('history-sip-amendment')}
            </Button>
          </div>

          <div className='table-responsive mt-5 bdr'>
            {/* Table Head */}
            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
              <thead>
                <tr className='fw-bold d-flex jusify-content-center w-100 align-items-center'>
                  <th className='td-order-1 text-center'>{t('kontrak-item')}</th>
                  <th className='td-order-3 text-center'>Status</th>
                  <th className='td-order-3 text-center'>{t('kontrak-aksi')}</th>
                  <th className='td-order-4 text-center'>Sales Org</th>
                  <th className='td-order-2 text-center'>{t('kontrak-incoterm')}</th>
                  <th className='td-order-4 text-center'>{t('kontrak-wilayah')}</th>
                  {sektorID == 1 ? <th className='td-order-2 text-center'>{t('segment')}</th> : ''}
                  <th className='td-order-4 text-center'>{t('sub-order-endUser')}</th>
                  {sektorID != 2 ? '' : <th className='td-order-2 text-center'>{t('Sektor')}</th>}
                  <th className='td-order-2 text-center'>{t('kontrak-jenis')}</th>
                  <th className='td-order-2 text-center'>{t('Product Code')}</th>
                  <th className='td-order-4 text-center'>{t('kontrak-nama')}</th>
                  <th className='td-order-2 text-center'>{t('kontrak-spek')}</th>
                  {retailFlag == 'AR03' ? (
                    <>
                      <th className='td-order-2 text-center'>{t('Kuantum Pengajuan')}</th>
                      <th className='td-order-2 text-center'>{t('Harga Pengajuan')}</th>
                      <th className='td-order-2 text-center'>{t('Shipping Tolerance')}</th>
                    </>
                  ) : (
                    <>
                      <th className='td-order-2 text-center'>{t('Kuantum Pengajuan')}</th>
                      {sektorID != 2 && (
                        <th className='td-order-2 text-center'>{t('sub-order-kuantumD')}</th>
                      )}
                      <th className='td-order-2 text-center'>{t('Shipping Tolerance')}</th>
                      <th className='td-order-2 text-center'>{t('Harga Pengajuan')}</th>
                      {sektorID != 2 && (
                        <th className='td-order-2 text-center'>{t('sub-order-hargaD')}</th>
                      )}
                    </>
                  )}
                  {sektorID == 1 && <th className='td-order-2 text-center'>Status {t('Price')}</th>}
                  <th className='td-order-2 text-center'>{t('Tonase Kontrak')}</th>
                  <th className='td-order-2 text-center'>{t('Tonase SO')}</th>
                  <th className='td-order-2 text-center'>{t('Tonase DO')}</th>
                  <th className='td-order-2 text-center'>Outstanding SO</th>
                  <th className='td-order-2 text-center'>Outstanding {t('Kontrak')}</th>
                  {sektorID == 2 && (
                    <th className='td-order-2 text-center'>{t('kontrak-gudang')}</th>
                  )}
                </tr>
              </thead>
              {dataSIPDetail.map((data: any, _index: any) => (
                <>
                  {allID.indexOf(data.id) != -1 && (
                    <tbody>
                      <tr className='d-flex jusify-content-center w-100 align-items-center'>
                        <td className='td-order-1 text-center column'>
                          <span className='d-block fs-6 py-3'>{_index + 1}</span>
                        </td>
                        <td className='td-order-3 text-center column'>
                          <BadgeColorSIP
                            status={data?.status_sip}
                            text={data?.status_text_sip}
                            type='item'
                          />
                        </td>
                        <td className='td-order-3 text-center column'>
                          <div
                            className='d-flex justify-content-center align-items-center'
                            style={{margin: '1px 0'}}
                          >
                            <button
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title='Detail'
                              onClick={() => {
                                handleShowOrderDetail(data)
                              }}
                            >
                              <KTSVG
                                path='/media/icons/duotune/file-text-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                            <button
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t('order-lampiran')}
                              onClick={() => {
                                // setIsLoadingModal(true)
                                // setShowUpload(true)
                                // setFileBox(data)
                                // setSubOrderID(
                                //   data.order_sub_item_id == null
                                //     ? data?.id
                                //     : data?.order_sub_item_id
                                // )
                                // setSIPNumberAttactment(data.SIP_number)
                                // ambilAttachment(
                                //   data.order_sub_item_id == null
                                //     ? data?.id
                                //     : data?.order_sub_item_id
                                // )
                                setShowUpload(true)
                                setItemEditing(data)
                                setAttachmentType('order-item')
                              }}
                            >
                              <KTSVG
                                path='/media/icons/duotune/archive-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                            <button
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t('Jadwal')}
                              onClick={() => {
                                setIDSector(data.sector_id)
                                setProvinceName(data.province?.region_name)
                                setCityName(data.city?.city_name)
                                setProductName(data.product_name)
                                formattingTon(data.fixed_quantum)
                                setReqeustQuantum(data.request_quantum)
                                setSubOrderID(
                                  data.order_sub_item_id == null
                                    ? data?.id
                                    : data?.order_sub_item_id
                                )
                                handleshowjadwal()
                              }}
                            >
                              <KTSVG
                                path='/media/icons/duotune/calendar-check-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                            <button
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t('Hapus')}
                              hidden={isAmandemend && hakAkses?.update ? true : false}
                              onClick={() => removeSubOrder(_index)}
                            >
                              <KTSVG
                                path='/media/icons/duotune/trash-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                          </div>
                        </td>
                        <td className='td-order-4 text-center column'>
                          <span className='d-block fs-6 py-3'>{data.produsen?.name}</span>
                        </td>
                        {data.sector?.id == 2 ? (
                          <>
                            {data.incoterm2 == null ? (
                              <td className='td-order-2 text-center column'>
                                <span className='d-block fs-6 py-3'>
                                  {data.incoterm1?.code}-{data.incoterm2_id}
                                </span>
                              </td>
                            ) : (
                              <td className='td-order-2 text-center column'>
                                <span className='d-block fs-6 py-3'>
                                  {data.incoterm1?.code}-{data.incoterm2?.code}
                                </span>
                              </td>
                            )}
                          </>
                        ) : (
                          <>
                            {data.incoterm2 == null ? (
                              <td className='td-order-2 text-center column'>
                                <span className='d-block fs-6 py-3'>
                                  {data.incoterm1?.code}
                                  {data.incoterm2_id == null || data.incoterm2_id == '0'
                                    ? ''
                                    : '-' + data.incoterm2_id}
                                </span>
                              </td>
                            ) : (
                              <td className='td-order-2 text-center column'>
                                <span className='d-block fs-6 py-3'>
                                  {data.incoterm1?.code}-{data.incoterm2?.code}
                                </span>
                              </td>
                            )}
                          </>
                        )}
                        <td className='td-order-4 text-center column'>
                          <span className='d-block fs-6 py-3'>
                            <PopoverText
                              content={
                                data.province?.region_name ||
                                '' + (data.city?.city_name ? ', ' + data.city?.city_name : '')
                              }
                              index={_index}
                              className='spec-sliceee'
                            />
                          </span>
                        </td>
                        {sektorID != 2 ? (
                          ''
                        ) : (
                          <td className='td-order-2 text-center column'>
                            <span className='d-block fs-6 py-3'>{t(data.sector?.name)}</span>
                          </td>
                        )}
                        {sektorID == 1 ? (
                          <td className='td-order-2 text-center column'>
                            <span className='d-block fs-6 py-3'>{t(data.segment_name)}</span>
                          </td>
                        ) : (
                          ''
                        )}
                        <td className='td-order-4 text-center column'>
                          {/* <span className='d-block fs-6 py-3'>
                            {data?.end_user_multiple ? handleShowEndUser(data.end_user) : data.end_user}
                          </span> */}
                          <span className='d-block fs-6 py-3'>
                            <PopoverText
                              content={
                                data?.end_user_multiple
                                  ? handleShowValue(data.end_user)
                                  : data.end_user
                              }
                              index={_index}
                              className='desc-slicee'
                            />
                          </span>
                        </td>
                        <td className='td-order-2 text-center column'>
                          <span className='d-block fs-6 py-3'>{data.product_type_desc}</span>
                        </td>
                        <td className='td-order-2 text-center column'>
                          <span className='d-block fs-6 py-3'>
                            {parseInt(data.material_number) == 0
                              ? ''
                              : data.material_number?.slice(-7)}
                          </span>
                        </td>
                        <td className='td-order-4 text-center column'>
                          <span className='d-block fs-6 py-3'>{data.product_name}</span>
                        </td>
                        <td className='td-order-2 text-center column'>
                          <span className='d-block fs-6 py-3'>
                            <PopoverText
                              content={data.product_spec ? data.product_spec : '-'}
                              index={_index}
                              className='spec-slicee'
                            />
                          </span>
                        </td>
                        {retailFlag == 'AR03' ? (
                          <>
                            {sektorID != 2 && (
                              <td className='td-order-2 text-center column'>
                                <span className='d-block fs-6 py-3'>
                                  {i18next.language === 'en'
                                    ? data.request_quantum?.toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                      })
                                    : data.request_quantum?.toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      })}{' '}
                                  {data.sector_id === 3 ? ' MT' : ' Ton'}
                                </span>
                              </td>
                            )}

                            <td className='td-order-2 text-center column'>
                              <span className='d-block fs-6 py-3'>
                                {i18next.language === 'en'
                                  ? data.fixed_quantum?.toLocaleString('en', {
                                      maximumFractionDigits: 4,
                                    })
                                  : data.fixed_quantum?.toLocaleString('id', {
                                      maximumFractionDigits: 4,
                                    })}{' '}
                                {data.sector_id === 3 ? ' MT' : ' Ton'}
                              </span>
                            </td>
                            <td className='td-order-2 text-center column'>
                              <span className='d-block fs-6 py-3'>{data?.shipping_tolerance}%</span>
                            </td>

                            {sektorID != 2 && (
                              <>
                                {data.is_formulated_price ? (
                                  <>
                                    <td className='td-order-2 text-center column'>
                                      <span className='d-block fs-6 py-3'>
                                        {t('Formulated Price')}
                                      </span>
                                    </td>
                                  </>
                                ) : (
                                  <>
                                    {sektorID == 1 ? (
                                      <>
                                        <td className='td-order-2 text-center column'>
                                          <span className='d-block fs-6 py-3'>
                                            {'Rp' + i18next.language === 'en'
                                              ? data.request_price?.toLocaleString('en', {
                                                  maximumFractionDigits: 4,
                                                })
                                              : data.request_price?.toLocaleString('id', {
                                                  maximumFractionDigits: 4,
                                                })}
                                            /Ton
                                          </span>
                                        </td>
                                      </>
                                    ) : (
                                      <>
                                        <td className='td-order-2 text-center column'>
                                          <span className='d-block fs-6 py-3'>
                                            USD {PriceFormater(data.request_price)} /MT
                                          </span>
                                        </td>
                                      </>
                                    )}
                                  </>
                                )}
                              </>
                            )}

                            {sektorID != 3 ? (
                              <td className='td-order-2 text-center column'>
                                <span className='d-block fs-6 py-3'>
                                  {'Rp' + i18next.language === 'en'
                                    ? data.fixed_price?.toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                      })
                                    : data.fixed_price?.toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      })}
                                  /Ton
                                </span>
                              </td>
                            ) : (
                              <td className='td-order-2 text-center column'>
                                <span className='d-block fs-6 py-3'>
                                  USD {PriceFormater(data.fixed_price)} /MT
                                </span>
                              </td>
                            )}
                          </>
                        ) : (
                          <>
                            {sektorID != 2 && (
                              <td className='td-order-2 text-center column'>
                                <span className='d-block fs-6 py-3'>
                                  {i18next.language === 'en'
                                    ? data.request_quantum?.toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                      })
                                    : data.request_quantum?.toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      })}{' '}
                                  {data.sector_id === 3 ? ' MT' : ' Ton'}
                                </span>
                              </td>
                            )}

                            <td className='td-order-2 text-center column'>
                              <span className='d-block fs-6 py-3'>
                                {i18next.language === 'en'
                                  ? data.fixed_quantum?.toLocaleString('en', {
                                      maximumFractionDigits: 4,
                                    })
                                  : data.fixed_quantum?.toLocaleString('id', {
                                      maximumFractionDigits: 4,
                                    })}{' '}
                                {data.sector_id === 3 ? ' MT' : ' Ton'}
                              </span>
                            </td>

                            <td className='td-order-2 text-center column'>
                              <span className='d-block fs-6 py-3'>{data?.shipping_tolerance}%</span>
                            </td>

                            {sektorID != 2 && (
                              <>
                                {data.is_formulated_price ? (
                                  <>
                                    <td className='td-order-2 text-center column'>
                                      <span className='d-block fs-6 py-3'>
                                        {t('Formulated Price')}
                                      </span>
                                    </td>
                                  </>
                                ) : (
                                  <>
                                    {sektorID == 1 ? (
                                      <>
                                        <td className='td-order-2 text-center column'>
                                          <span className='d-block fs-6 py-3'>
                                            {'Rp' + i18next.language === 'en'
                                              ? data.request_price?.toLocaleString('en', {
                                                  maximumFractionDigits: 4,
                                                })
                                              : data.request_price?.toLocaleString('id', {
                                                  maximumFractionDigits: 4,
                                                })}
                                            /Ton
                                          </span>
                                        </td>
                                      </>
                                    ) : (
                                      <>
                                        <td className='td-order-2 text-center column'>
                                          <span className='d-block fs-6 py-3'>
                                            USD {PriceFormater(data.request_price)} /MT
                                          </span>
                                        </td>
                                      </>
                                    )}
                                  </>
                                )}
                              </>
                            )}

                            {sektorID != 3 ? (
                              <td className='td-order-2 text-center column'>
                                <span className='d-block fs-6 py-3'>
                                  {'Rp' + i18next.language === 'en'
                                    ? data.fixed_price?.toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                      })
                                    : data.fixed_price?.toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      })}
                                  /Ton
                                </span>
                              </td>
                            ) : (
                              <td className='td-order-2 text-center column'>
                                <span className='d-block fs-6 py-3'>
                                  USD {PriceFormater(data.fixed_price)} /MT
                                </span>
                              </td>
                            )}
                          </>
                        )}
                        {data.sector_id == 1 && (
                          <td className='td-order-2 text-center column'>
                            <span className='d-block fs-6 py-3'>
                              {data.include_ppn ? 'Include PPN' : 'Exclude PPN'}
                            </span>
                          </td>
                        )}
                        <td className='td-order-2 text-center column'>
                          <span className='d-block fs-6 py-3'>
                            {i18next.language === 'en'
                              ? data.quantum_contract?.toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                })
                              : data.quantum_contract?.toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                })}{' '}
                            {data.sector_id === 3 ? ' MT' : ' Ton'}
                          </span>
                        </td>
                        <td className='td-order-2 text-center column'>
                          <span className='d-block fs-6 py-3'>
                            {i18next.language === 'en'
                              ? data.quantum_realisazied?.toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                })
                              : data.quantum_realisazied?.toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                })}{' '}
                            {data.sector_id === 3 ? ' MT' : ' Ton'}
                          </span>
                        </td>
                        <td className='td-order-2 text-center column'>
                          <span className='d-block fs-6 py-3'>
                            {i18next.language === 'en'
                              ? data.quantum_do?.toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                })
                              : data.quantum_do?.toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                })}{' '}
                            {data.sector_id === 3 ? ' MT' : ' Ton'}
                          </span>
                        </td>
                        <td className='td-order-2 text-center column'>
                          <span className='d-block fs-6 py-3'>
                            {i18next.language === 'en'
                              ? data.outstanding_quantum_so?.toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                })
                              : data.outstanding_quantum_so?.toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                })}{' '}
                            {data.sector_id === 3 ? ' MT' : ' Ton'}
                          </span>
                        </td>
                        <td className='td-order-2 text-center column'>
                          <span className='d-block fs-6 py-3'>
                            {i18next.language === 'en'
                              ? data.left_over_quantum_no_st?.toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                })
                              : data.left_over_quantum_no_st?.toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                })}{' '}
                            {data.sector_id === 3 ? ' MT' : ' Ton'}
                          </span>
                        </td>
                        {data.sector_id == 2 ? (
                          <td className='td-order-2 text-center column'>
                            <span className='d-block fs-6 py-3'>
                              <PopoverText
                                content={data.plant_desc || '-'}
                                index={_index}
                                placement='bottom'
                                className='spec-sliceee'
                              />
                            </span>
                          </td>
                        ) : (
                          ''
                        )}
                      </tr>
                    </tbody>
                  )}
                </>
              ))}
              {addedNewItem.map((data: any, _index: any) => (
                <tbody key={data?.id ?? _index}>
                  <tr className='d-flex jusify-content-center w-100 align-items-center'>
                    <td className='td-order-1 text-center column'>
                      <span className='d-block fs-6 py-3'>{addedNewItem.length + _index + 1}</span>
                    </td>
                    <td className='td-order-3 text-center column'>
                      <BadgeColorSIP status={data.status} text={data.status_text} type='item' />
                    </td>
                    <td className='td-order-3 text-center column'>
                      <div
                        className='d-flex justify-content-center align-items-center'
                        style={{margin: '-1px 0 0 0'}}
                      >
                        <button
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          data-bs-trigger='hover'
                          title='Detail'
                          onClick={() => {
                            handleShowOrderDetail(data)
                          }}
                        >
                          <KTSVG
                            path='/media/icons/duotune/file-text-fill.svg'
                            className='svg-icon-3'
                          />
                        </button>
                        <button
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          data-bs-trigger='hover'
                          title={t('order-lampiran')}
                          onClick={() => {
                            // setIsLoadingModal(true)
                            // setShowUpload(true)
                            // setFileBox(data)
                            // setSubOrderID(
                            //   data.order_sub_item_id == null ? data?.id : data?.order_sub_item_id
                            // )
                            // setSIPNumberAttactment(data.SIP_number)
                            // ambilAttachment(
                            //   data.order_sub_item_id == null ? data?.id : data?.order_sub_item_id
                            // )
                            setShowUpload(true)
                            setItemEditing(data)
                            setAttachmentType('order-item')
                          }}
                        >
                          <KTSVG
                            path='/media/icons/duotune/archive-fill.svg'
                            className='svg-icon-3'
                          />
                        </button>
                        <button
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          data-bs-trigger='hover'
                          title={t('Jadwal')}
                          onClick={() => {
                            setIDSector(data.sector_id)
                            setProvinceName(data.province?.region_name)
                            setCityName(data.city?.city_name)
                            setProductName(data.product_name)
                            formattingTon(data.fixed_quantum)
                            setReqeustQuantum(data.request_quantum)
                            setSubOrderID(
                              data.order_sub_item_id == null ? data?.id : data?.order_sub_item_id
                            )
                            handleshowjadwal()
                          }}
                        >
                          <KTSVG
                            path='/media/icons/duotune/calendar-check-fill.svg'
                            className='svg-icon-3'
                          />
                        </button>
                        <button
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          data-bs-trigger='hover'
                          title={t('Hapus')}
                          onClick={() => removeSubOrder2(_index)}
                        >
                          <KTSVG
                            path='/media/icons/duotune/trash-fill.svg'
                            className='svg-icon-3'
                          />
                        </button>
                      </div>
                    </td>
                    <td className='td-order-4 text-center column'>
                      <span className='d-block fs-6 py-3'>{data.produsen?.name}</span>
                    </td>
                    {data.sector?.id == 2 ? (
                      <>
                        {data.incoterm2 == null ? (
                          <td className='td-order-2 text-center column'>
                            <span className='d-block fs-6 py-3'>
                              {data.incoterm1?.code}-{data.incoterm2_id}
                            </span>
                          </td>
                        ) : (
                          <td className='td-order-2 text-center column'>
                            <span className='d-block fs-6 py-3'>
                              {data.incoterm1?.code}-{data.incoterm2?.code}
                            </span>
                          </td>
                        )}
                      </>
                    ) : (
                      <>
                        {data.incoterm2 == null ? (
                          <td className='td-order-2 text-center column'>
                            <span className='d-block fs-6 py-3'>
                              {data.incoterm1?.code}
                              {data.incoterm2_id == null || data.incoterm2_id == '0'
                                ? ''
                                : '-' + data.incoterm2_id}
                            </span>
                          </td>
                        ) : (
                          <td className='td-order-2 text-center column'>
                            <span className='d-block fs-6 py-3'>
                              {data.incoterm1?.code}-{data.incoterm2?.code}
                            </span>
                          </td>
                        )}
                      </>
                    )}
                    <td className='td-order-4 text-center column'>
                      <span className='d-block fs-6 py-3'>
                        <PopoverText
                          content={
                            data.province?.region_name +
                            (data.city?.city_name ? ', ' + data.city?.city_name : '')
                          }
                          index={_index}
                          className='spec-sliceee'
                        />
                      </span>
                    </td>
                    {sektorID != 2 ? (
                      ''
                    ) : (
                      <td className='td-order-2 text-center column'>
                        <span className='d-block fs-6 py-3'>{t(data.sector?.name)}</span>
                      </td>
                    )}
                    {sektorID == 1 ? (
                      <td className='td-order-2 text-center column'>
                        <span className='d-block fs-6 py-3'>{t(data.segment_name)}</span>
                      </td>
                    ) : (
                      ''
                    )}
                    <td className='td-order-4 text-center column'>
                      <span className='d-block fs-6 py-3'>
                        <PopoverText
                          content={
                            data?.end_user_multiple ? handleShowValue(data.end_user) : data.end_user
                          }
                          index={_index}
                          className='desc-slicee'
                        />
                      </span>
                    </td>
                    <td className='td-order-2 text-center column'>
                      <span className='d-block fs-6 py-3'>{data.product_type_desc}</span>
                    </td>
                    <td className='td-order-2 text-center column'>
                      <span className='d-block fs-6 py-3'>
                        {parseInt(data.material_number) == 0 ? '' : data.material_number?.slice(-7)}
                      </span>
                    </td>
                    <td className='td-order-4 text-center column'>
                      <span className='d-block fs-6 py-3'>{data.product_name}</span>
                    </td>
                    <td className='td-order-2 text-center column'>
                      <span className='d-block fs-6 py-3'>
                        <PopoverText
                          content={data.product_spec ? data.product_spec : '-'}
                          index={_index}
                          className='spec-slicee'
                        />
                      </span>
                    </td>
                    {retailFlag == 'AR03' ? (
                      <>
                        {sektorID != 2 && (
                          <td className='td-order-2 text-center column'>
                            <span className='d-block fs-6 py-3'>
                              {i18next.language === 'en'
                                ? data.request_quantum?.toLocaleString('en', {
                                    maximumFractionDigits: 4,
                                  })
                                : data.request_quantum?.toLocaleString('id', {
                                    maximumFractionDigits: 4,
                                  })}{' '}
                              {data.sector_id === 3 ? ' MT' : ' Ton'}
                            </span>
                          </td>
                        )}

                        <td className='td-order-2 text-center column'>
                          <span className='d-block fs-6 py-3'>
                            {i18next.language === 'en'
                              ? data.fixed_quantum?.toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                })
                              : data.fixed_quantum?.toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                })}{' '}
                            {data.sector_id === 3 ? ' MT' : ' Ton'}
                          </span>
                        </td>
                        <td className='td-order-2 text-center column'>
                          <span className='d-block fs-6 py-3'>{data?.shipping_tolerance}%</span>
                        </td>

                        {sektorID != 2 && (
                          <>
                            {data.is_formulated_price ? (
                              <>
                                <td className='td-order-2 text-center column'>
                                  <span className='d-block fs-6 py-3'>{t('Formulated Price')}</span>
                                </td>
                              </>
                            ) : (
                              <>
                                {sektorID == 1 ? (
                                  <>
                                    <td className='td-order-2 text-center column'>
                                      <span className='d-block fs-6 py-3'>
                                        {'Rp' + i18next.language === 'en'
                                          ? data.request_price?.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            })
                                          : data.request_price?.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            })}
                                        /Ton
                                      </span>
                                    </td>
                                  </>
                                ) : (
                                  <>
                                    <td className='td-order-2 text-center column'>
                                      <span className='d-block fs-6 py-3'>
                                        USD {PriceFormater(data.request_price)} /MT
                                      </span>
                                    </td>
                                  </>
                                )}
                              </>
                            )}
                          </>
                        )}

                        {sektorID != 3 ? (
                          <td className='td-order-2 text-center column'>
                            <span className='d-block fs-6 py-3'>
                              {'Rp' + i18next.language === 'en'
                                ? data.fixed_price?.toLocaleString('en', {maximumFractionDigits: 4})
                                : data.fixed_price?.toLocaleString('id', {
                                    maximumFractionDigits: 4,
                                  })}
                              /Ton
                            </span>
                          </td>
                        ) : (
                          <td className='td-order-2 text-center column'>
                            <span className='d-block fs-6 py-3'>
                              USD {PriceFormater(data.fixed_price)} /MT
                            </span>
                          </td>
                        )}
                      </>
                    ) : (
                      <>
                        {sektorID != 2 && (
                          <td className='td-order-2 text-center column'>
                            <span className='d-block fs-6 py-3'>
                              {i18next.language === 'en'
                                ? data.request_quantum?.toLocaleString('en', {
                                    maximumFractionDigits: 4,
                                  })
                                : data.request_quantum?.toLocaleString('id', {
                                    maximumFractionDigits: 4,
                                  })}{' '}
                              {data.sector_id === 3 ? ' MT' : ' Ton'}
                            </span>
                          </td>
                        )}

                        <td className='td-order-2 text-center column'>
                          <span className='d-block fs-6 py-3'>
                            {i18next.language === 'en'
                              ? data.fixed_quantum?.toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                })
                              : data.fixed_quantum?.toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                })}{' '}
                            {data.sector_id === 3 ? ' MT' : ' Ton'}
                          </span>
                        </td>

                        <td className='td-order-2 text-center column'>
                          <span className='d-block fs-6 py-3'>{data?.shipping_tolerance}%</span>
                        </td>

                        {sektorID != 2 && (
                          <>
                            {data.is_formulated_price ? (
                              <>
                                <td className='td-order-2 text-center column'>
                                  <span className='d-block fs-6 py-3'>{t('Formulated Price')}</span>
                                </td>
                              </>
                            ) : (
                              <>
                                {sektorID == 1 ? (
                                  <>
                                    <td className='td-order-2 text-center column'>
                                      <span className='d-block fs-6 py-3'>
                                        {'Rp' + i18next.language === 'en'
                                          ? data.request_price?.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            })
                                          : data.request_price?.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            })}
                                        /Ton
                                      </span>
                                    </td>
                                  </>
                                ) : (
                                  <>
                                    <td className='td-order-2 text-center column'>
                                      <span className='d-block fs-6 py-3'>
                                        USD {PriceFormater(data.request_price)} /MT
                                      </span>
                                    </td>
                                  </>
                                )}
                              </>
                            )}
                          </>
                        )}

                        {sektorID != 3 ? (
                          <td className='td-order-2 text-center column'>
                            <span className='d-block fs-6 py-3'>
                              {'Rp' + i18next.language === 'en'
                                ? data.fixed_price?.toLocaleString('en', {maximumFractionDigits: 4})
                                : data.fixed_price?.toLocaleString('id', {
                                    maximumFractionDigits: 4,
                                  })}
                              /Ton
                            </span>
                          </td>
                        ) : (
                          <td className='td-order-2 text-center column'>
                            <span className='d-block fs-6 py-3'>
                              USD {PriceFormater(data.fixed_price)} /MT
                            </span>
                          </td>
                        )}
                      </>
                    )}
                    {data.sector_id == 1 && (
                      <td className='td-order-2 text-center column'>
                        <span className='d-block fs-6 py-3'>
                          {data.include_ppn ? 'Include PPN' : 'Exclude PPN'}
                        </span>
                      </td>
                    )}
                    <td className='td-order-2 text-center column'>
                      <span className='d-block fs-6 py-3'>
                        {i18next.language === 'en'
                          ? data.quantum_contract?.toLocaleString('en', {
                              maximumFractionDigits: 4,
                            })
                          : data.quantum_contract?.toLocaleString('id', {
                              maximumFractionDigits: 4,
                            })}{' '}
                        {data.sector_id === 3 ? ' MT' : ' Ton'}
                      </span>
                    </td>
                    <td className='td-order-2 text-center column'>
                      <span className='d-block fs-6 py-3'>
                        {i18next.language === 'en'
                          ? data.quantum_realisazied?.toLocaleString('en', {
                              maximumFractionDigits: 4,
                            })
                          : data.quantum_realisazied?.toLocaleString('id', {
                              maximumFractionDigits: 4,
                            })}{' '}
                        {data.sector_id === 3 ? ' MT' : ' Ton'}
                      </span>
                    </td>
                    <td className='td-order-2 text-center column'>
                      <span className='d-block fs-6 py-3'>
                        {i18next.language === 'en'
                          ? data.quantum_do?.toLocaleString('en', {
                              maximumFractionDigits: 4,
                            })
                          : data.quantum_do?.toLocaleString('id', {
                              maximumFractionDigits: 4,
                            })}{' '}
                        {data.sector_id === 3 ? ' MT' : ' Ton'}
                      </span>
                    </td>
                    <td className='td-order-2 text-center column'>
                      <span className='d-block fs-6 py-3'>
                        {i18next.language === 'en'
                          ? data.outstanding_quantum_so?.toLocaleString('en', {
                              maximumFractionDigits: 4,
                            })
                          : data.outstanding_quantum_so?.toLocaleString('id', {
                              maximumFractionDigits: 4,
                            })}{' '}
                        {data.sector_id === 3 ? ' MT' : ' Ton'}
                      </span>
                    </td>
                    <td className='td-order-2 text-center column'>
                      <span className='d-block fs-6 py-3'>
                        {i18next.language === 'en'
                          ? data.left_over_quantum_no_st?.toLocaleString('en', {
                              maximumFractionDigits: 4,
                            })
                          : data.left_over_quantum_no_st?.toLocaleString('id', {
                              maximumFractionDigits: 4,
                            })}{' '}
                        {data.sector_id === 3 ? ' MT' : ' Ton'}
                      </span>
                    </td>
                    {data.sector_id == 2 ? (
                      <td className='td-order-2 text-center column'>
                        <span className='d-block fs-6 py-3'>
                          <PopoverText
                            content={data.plant_desc || '-'}
                            index={_index}
                            placement='bottom'
                            className='spec-sliceee'
                          />
                        </span>
                      </td>
                    ) : (
                      ''
                    )}
                  </tr>
                </tbody>
              ))}
            </table>
            {/* End Table Head */}
          </div>

          <table className='mt-4'>
            <tr>
              <td className='td-250'>
                <p className='fs-4 me-2'>Total {t('kontrak-kuantum')}</p>
              </td>
              <td>
                <Form.Control
                  aria-label='Default select example'
                  size='sm'
                  value={
                    (i18next.language === 'en'
                      ? (quantum + quantum2)?.toLocaleString('en', {maximumFractionDigits: 4})
                      : (quantum + quantum2)?.toLocaleString('id', {maximumFractionDigits: 4})) +
                    ' ' +
                    'Ton'
                  }
                  disabled
                />
              </td>
            </tr>
          </table>

          <table className='mt-4'>
            <tr>
              <td className='td-250'>
                <p className='fs-4 me-2'>{t('Grand Total')}</p>
              </td>
              <td>
                {sektorID != 3 ? (
                  (grandtotalUsd + grandtotal2usd) > 0 ?
                  <Form.Control
                    aria-label='Default select example'
                    size='sm'
                    value={
                      'USD ' + ((i18next.language === 'en'
                        ? (grandtotalUsd + grandtotal2usd).toLocaleString('en', {
                            maximumFractionDigits: 4,
                          })
                        : (grandtotalUsd + grandtotal2usd).toLocaleString('id', {
                            maximumFractionDigits: 4,
                          })))
                    }
                    disabled
                  /> : <Form.Control
                    aria-label='Default select example'
                    size='sm'
                    value={
                      'Rp ' + ((i18next.language === 'en'
                        ? (grandtotal + grandtotal2).toLocaleString('en', {
                            maximumFractionDigits: 4,
                          })
                        : (grandtotal + grandtotal2).toLocaleString('id', {
                            maximumFractionDigits: 4,
                          })))
                    }
                    disabled
                  />
                ) : (
                  <Form.Control
                    aria-label='Default select example'
                    size='sm'
                    value={'USD ' + PriceFormater(grandtotal + grandtotal2)}
                    disabled
                  />
                )}
              </td>
            </tr>
          </table>

          <hr/>

          { allItems.length && <SettingApproval
              items={allItems}
              reviewers={reviewers}
              approvers={approvers}
              onChangeReviewers={onChangeReviewers}
              onChangeApprovers={onChangeApprovers}
            /> }

          <hr/>

          <div className='d-flex justify-content-end mt-5'>
            <Button
              variant='primary'
              className='ml-2 me-2'
              hidden={isAmandemend && hakAkses?.update ? false : true}
              onClick={() => updateAmandemen()}
            >
              {isLoading ? (
                <Spinner animation='border' variant='light' size='sm' />
              ) : (
                <div>
                  {t('Update Amendment SIP')}
                </div>
              )}
            </Button>
            <Button
              variant='primary'
              className='ml-2 me-2'
              hidden={isAmandemend && hakAkses?.update ? true : false}
              onClick={() => submitEditSIP()}
              disabled={isLoading}
            >
              {isLoading ? (
                <Spinner animation='border' variant='light' size='sm' />
              ) : (
                <div>
                  {t('Update SIP')}
                </div>
              )}
            </Button>
          </div>
        </div>
        {/* begin::Header */}

        <AttachmentModal 
          onStoreAttachmentNewProduct={() => false} 
          item={itemEditing} 
          show={showUpload} 
          type={attachmentType}
          onCloseModal={() => 
          setShowUpload(false)} 
        />

        <CustomModal
          title='Detail SIP'
          size='xl'
          show={showDetail}
          onHide={() => setShowDetail(false)}
        >
          <FormDetailSIP />
        </CustomModal>

        <Modal
          show={showJadwal}
          onHide={() => setShowJadwal(false)}
          centered
          size='xl'
          backdrop='static'
          keyboard={false}
          scrollable
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {idSektor != 3 ? provinceName + ', ' + cityName + ' | ' : ''}
              {productName} | {fixedQuantum} Ton
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <span style={{fontSize: '15px'}} className='fw-bold d-block'>
              {t('Jadwal')}
            </span>
            <AddRemoveJadwal id={subOrderID} is_amendment={'false'} />
          </Modal.Body>
        </Modal>

        <Modal
          show={showAddItem}
          onHide={() => setShowAddItem(false)}
          backdrop='static'
          keyboard={false}
          centered
          scrollable
          size='xl'
        >
          <Modal.Header closeButton>
            <Modal.Title>{t('pilih')} Item</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Accordion>
              {fullPengajuanOrder.map((data: any, _index: any) => (
                <>
                  {/* <label>{indexOrder.indexOf(_index)} {indexOrder[_index]}</label> */}
                  {allID.indexOf(data.id) == -1 && (
                    <>
                      <Accordion.Item eventKey={data?.id}>
                        <Accordion.Header>
                          {data?.id} / {data?.produsen?.name} / {data?.product_name} /{' '}
                          {data?.incoterm1?.code}
                          {data?.incoterm2 == null
                            ? data?.incoterm2_id == null || data?.incoterm2_id == '0'
                              ? ''
                              : ' - ' + data?.incoterm2_id
                            : ' - ' + data?.incoterm2?.code}{' '}
                          /{' '}
                          {data?.provice
                            ? data.province?.region_name + ' - ' + data?.city?.city_name + ' /'
                            : ''}{' '}
                          {(i18next.language === 'en'
                            ? data.fixed_quantum?.toLocaleString('en', {maximumFractionDigits: 4})
                            : data.fixed_quantum?.toLocaleString('id', {
                                maximumFractionDigits: 4,
                              })) + (data.sector_id === 3 ? ' MT' : ' Ton')}
                        </Accordion.Header>
                        <Accordion.Body style={{backgroundColor: 'white'}}>
                          {sektorID == 2 && (
                            <Row>
                              <Col md={6}>
                                <Row className='mb-4'>
                                  {data.have_action && (
                                    <>
                                      <Col md={4}>
                                        <p>{t('pilih')}</p>
                                      </Col>
                                      <Col md={8}>
                                        <input
                                          className='form-check-input'
                                          type='checkbox'
                                          id={'checkbox' + data.id}
                                          value={data.id}
                                          onClick={() => onclickCheckBox(data.id)}
                                        />
                                      </Col>
                                    </>
                                  )}
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('kontrak-item')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control value={data.id} disabled size='sm' />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>Sales Org</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control value={data.produsen?.name} disabled size='sm' />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('kontrak-wilayah')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      value={data.province?.region_name}
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('kontrak-Gudang')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control value={data.plant_desc} disabled size='sm' />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('kontrak-nama')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control value={data.product_name} disabled size='sm' />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('sub-order-kuantum')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      value={
                                        i18next.language === 'en'
                                          ? data.request_quantum?.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            }) + ' Ton'
                                          : data.request_quantum?.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            }) + ' Ton'
                                      }
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                              </Col>
                              <Col md={6}>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p>Status</p>
                                  </Col>
                                  <Col md={8}>
                                    <span className='d-block '>
                                      <span className='badge badge-light-primary'>
                                        {t(data.status_text)}
                                      </span>
                                    </span>
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('Sektor')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control value={t(data.sector?.name)} disabled size='sm' />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('kontrak-incoterm')}</p>
                                  </Col>
                                  <Col md={8}>
                                    {data.sector?.id == 2 ? (
                                      <>
                                        {data.incoterm2 == null ? (
                                          <Form.Control
                                            value={data.incoterm1?.code + ' - ' + data.incoterm2_id}
                                            disabled
                                            size='sm'
                                          />
                                        ) : (
                                          <Form.Control
                                            value={
                                              data.incoterm1?.code + ' - ' + data.incoterm2?.code
                                            }
                                            disabled
                                            size='sm'
                                          />
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        {data.incoterm2 == null ? (
                                          <Form.Control
                                            value={
                                              data.incoterm2_id == null || data.incoterm2_id == '0'
                                                ? data.incoterm1?.code
                                                : data.incoterm1?.code + '-' + data.incoterm2_id
                                            }
                                            disabled
                                            size='sm'
                                          />
                                        ) : (
                                          <Form.Control
                                            value={
                                              data.incoterm1?.code + ' - ' + data.incoterm2?.code
                                            }
                                            disabled
                                            size='sm'
                                          />
                                        )}
                                      </>
                                    )}
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('sub-order-kota')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      value={t(data.city?.city_name)}
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('kontrak-jenis')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      value={data.product_type_desc}
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('kontrak-spek')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      as='textarea'
                                      style={{height: '40px'}}
                                      value={data.product_spec}
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('sub-order-hargaP')}/Ton</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      value={
                                        'Rp' + i18next.language === 'en'
                                          ? data.request_price?.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            })
                                          : data.request_price?.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            })
                                      }
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          )}

                          {sektorID == 1 && (
                            <Row>
                              <Col md={6}>
                                <Row className='mb-4'>
                                  {data.have_action && (
                                    <>
                                      <Col md={4}>
                                        <p>{t('pilih')}</p>
                                      </Col>
                                      <Col md={8}>
                                        <input
                                          className='form-check-input'
                                          type='checkbox'
                                          id={'checkbox' + data.id}
                                          value={data.id}
                                          onClick={() => onclickCheckBox(data.id)}
                                        />
                                      </Col>
                                    </>
                                  )}
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('kontrak-item')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control value={data.id} disabled size='sm' />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>Sales Org</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control value={data.produsen?.name} disabled size='sm' />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('kontrak-wilayah')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      value={data.province?.region_name}
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('kontrak-jenis')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      value={data.product_type_desc}
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='fs-6'>{t('Kuantum Pengajuan')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      value={
                                        i18next.language === 'en'
                                          ? data.request_quantum?.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            }) + ' Ton'
                                          : data.request_quantum?.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            }) + ' Ton'
                                      }
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className=''>{t('sub-order-kuantumD')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      value={
                                        i18next.language === 'en'
                                          ? data.fixed_quantum?.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            }) + ' Ton'
                                          : data.fixed_quantum?.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            }) + ' Ton'
                                      }
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('kontrak-spek')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      as='textarea'
                                      style={{height: '40px'}}
                                      value={data.product_spec}
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3 fs-6'>{t('segment')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      type='text'
                                      value={t(data.segment_name)}
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                              </Col>
                              <Col md={6}>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p>Status</p>
                                  </Col>
                                  <Col md={8}>
                                    <span className='d-block '>
                                      <span className='badge badge-light-primary'>
                                        {t(data.status_text)}
                                      </span>
                                    </span>
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('Sektor')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control value={t(data.sector?.name)} disabled size='sm' />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('kontrak-incoterm')}</p>
                                  </Col>
                                  <Col md={8}>
                                    {data.sector?.id == 2 ? (
                                      <>
                                        {data.incoterm2 == null ? (
                                          <Form.Control
                                            value={data.incoterm1?.code + ' - ' + data.incoterm2_id}
                                            disabled
                                            size='sm'
                                          />
                                        ) : (
                                          <Form.Control
                                            value={
                                              data.incoterm1?.code + ' - ' + data.incoterm2?.code
                                            }
                                            disabled
                                            size='sm'
                                          />
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        {data.incoterm2 == null ? (
                                          <Form.Control
                                            value={
                                              data.incoterm2_id == null || data.incoterm2_id == '0'
                                                ? data.incoterm1?.code
                                                : data.incoterm1?.code + '-' + data.incoterm2_id
                                            }
                                            disabled
                                            size='sm'
                                          />
                                        ) : (
                                          <Form.Control
                                            value={
                                              data.incoterm1?.code + ' - ' + data.incoterm2?.code
                                            }
                                            disabled
                                            size='sm'
                                          />
                                        )}
                                      </>
                                    )}
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('sub-order-kota')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      value={t(data.city?.city_name)}
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('kontrak-nama')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control value={data.product_name} disabled size='sm' />
                                  </Col>
                                </Row>
                                {data.is_formulated_price ? (
                                  <>
                                    <Row className='mb-4'>
                                      <Col sm={5}>
                                        <p className='fs-6 mt-4'>{t('Formulated Price')}</p>
                                      </Col>
                                      <Col sm={7} className='d-flex justify-content-start'>
                                        <Form.Check
                                          reverse
                                          name='formula_Price'
                                          className='mt-5 mb-2'
                                          type='checkbox'
                                          id='formula_Price'
                                          checked={data?.is_formulated_price}
                                        />
                                      </Col>
                                    </Row>
                                  </>
                                ) : (
                                  <>
                                    <Row className='mb-4'>
                                      <Col md={4}>
                                        <p className=''>{t('sub-order-hargaP')}/Ton</p>
                                      </Col>
                                      <Col md={8}>
                                        <Form.Control
                                          value={
                                            'Rp' + i18next.language === 'en'
                                              ? data.request_price?.toLocaleString('en', {
                                                  maximumFractionDigits: 4,
                                                })
                                              : data.request_price?.toLocaleString('id', {
                                                  maximumFractionDigits: 4,
                                                })
                                          }
                                          disabled
                                          size='sm'
                                        />
                                      </Col>
                                    </Row>
                                  </>
                                )}
                                <Row className='mb-3'>
                                  <Col md={4} className='d-flex align-items-center'>
                                    <p className='fs-6'>{t('sub-order-hargaD')}/Ton</p>
                                  </Col>
                                  <Col md={8}>
                                    { data.price_usd != "0" ? <Form.Control
                                      aria-label='Default select example'
                                      size='sm'
                                      value={
                                        'USD ' + (i18next.language === 'en'
                                          ? data.price_usd?.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            })
                                          : data.price_usd?.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            }))
                                      }
                                      disabled
                                    /> : <Form.Control
                                      aria-label='Default select example'
                                      size='sm'
                                      value={
                                        'Rp ' + (i18next.language === 'en'
                                          ? data.fixed_price?.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            })
                                          : data.fixed_price?.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            }))
                                      }
                                      disabled
                                    /> }
                                  </Col>
                                </Row>

                                <Row className='mb-4'>
                                  <Col md={5}>
                                    <p className='mt-3 fs-6'>{t('termasuk-ppn')}</p>
                                  </Col>
                                  <Col md={7} className='d-flex justify-content-start'>
                                    <Form.Check
                                      reverse
                                      name='ppn'
                                      className='mt-3 mb-2'
                                      type='checkbox'
                                      id='ckbox-ppn'
                                      checked={data.include_ppn}
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('sub-order-catatan')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      as='textarea'
                                      style={{height: '40px'}}
                                      value={data.notes}
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          )}

                          {sektorID == 3 && (
                            <Row>
                              <Col md={6}>
                                <Row className='mb-4'>
                                  {data.have_action && (
                                    <>
                                      <Col md={4}>
                                        <p>{t('pilih')}</p>
                                      </Col>
                                      <Col md={8}>
                                        <input
                                          className='form-check-input'
                                          type='checkbox'
                                          id={'checkbox' + data.id}
                                          value={data.id}
                                          onClick={() => onclickCheckBox(data.id)}
                                        />
                                      </Col>
                                    </>
                                  )}
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('kontrak-item')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control value={data.id} disabled size='sm' />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>Sales Org</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control value={data.produsen?.name} disabled size='sm' />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('kontrak-wilayah')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      value={data.province?.region_name}
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('kontrak-jenis')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      value={data.product_type_desc}
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='fs-6'>{t('Kuantum Pengajuan')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      value={
                                        i18next.language === 'en'
                                          ? data.request_quantum?.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            }) + ' MT'
                                          : data.request_quantum?.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            }) + ' MT'
                                      }
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className=''>{t('sub-order-kuantumD')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      value={
                                        i18next.language === 'en'
                                          ? data.fixed_quantum?.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            }) + ' MT'
                                          : data.fixed_quantum?.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            }) + ' MT'
                                      }
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('kontrak-spek')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      as='textarea'
                                      style={{height: '40px'}}
                                      value={data.product_spec}
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                              </Col>
                              <Col md={6}>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p>Status</p>
                                  </Col>
                                  <Col md={8}>
                                    <span className='d-block '>
                                      <span className='badge badge-light-primary'>
                                        {t(data.status_text)}
                                      </span>
                                    </span>
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('Sektor')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control value={t(data.sector?.name)} disabled size='sm' />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('kontrak-incoterm')}</p>
                                  </Col>
                                  <Col md={8}>
                                    {data.sector?.id == 2 ? (
                                      <>
                                        {data.incoterm2 == null ? (
                                          <Form.Control
                                            value={data.incoterm1?.code + ' - ' + data.incoterm2_id}
                                            disabled
                                            size='sm'
                                          />
                                        ) : (
                                          <Form.Control
                                            value={
                                              data.incoterm1?.code + ' - ' + data.incoterm2?.code
                                            }
                                            disabled
                                            size='sm'
                                          />
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        {data.incoterm2 == null ? (
                                          <Form.Control
                                            value={
                                              data.incoterm2_id == null || data.incoterm2_id == '0'
                                                ? data.incoterm1?.code
                                                : data.incoterm1?.code + '-' + data.incoterm2_id
                                            }
                                            disabled
                                            size='sm'
                                          />
                                        ) : (
                                          <Form.Control
                                            value={
                                              data.incoterm1?.code + ' - ' + data.incoterm2?.code
                                            }
                                            disabled
                                            size='sm'
                                          />
                                        )}
                                      </>
                                    )}
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('sub-order-kota')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      value={t(data.city?.city_name)}
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('kontrak-nama')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control value={data.product_name} disabled size='sm' />
                                  </Col>
                                </Row>
                                {data.is_formulated_price ? (
                                  <>
                                    <Row className='mb-4'>
                                      <Col sm={5}>
                                        <p className='fs-6 mt-4'>{t('Formulated Price')}</p>
                                      </Col>
                                      <Col sm={7} className='d-flex justify-content-start'>
                                        <Form.Check
                                          reverse
                                          name='formula_Price'
                                          className='mt-5 mb-2'
                                          type='checkbox'
                                          id='formula_Price'
                                          checked={data?.is_formulated_price}
                                        />
                                      </Col>
                                    </Row>
                                  </>
                                ) : (
                                  <>
                                    <Row className='mb-4'>
                                      <Col md={4}>
                                        <p className=''>{t('sub-order-hargaP')}/MT</p>
                                      </Col>
                                      <Col md={8}>
                                        <Form.Control
                                          value={'USD' + PriceFormater(data?.request_price)}
                                          disabled
                                          size='sm'
                                        />
                                      </Col>
                                    </Row>
                                  </>
                                )}
                                <Row className='mb-3'>
                                  <Col md={4} className='d-flex align-items-center'>
                                    <p className='fs-6'>{t('sub-order-hargaD')}/MT</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      aria-label='Default select example'
                                      size='sm'
                                      value={'USD' + PriceFormater(data.fixed_price)}
                                      disabled
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('sub-order-catatan')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      as='textarea'
                                      style={{height: '40px'}}
                                      value={data.notes}
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          )}
                        </Accordion.Body>
                      </Accordion.Item>
                    </>
                  )}
                </>
              ))}
            </Accordion>
            <div className='d-flex justify-content-end mt-5'>
              <Button className='justify-content-end' onClick={() => addInOrder('satuan')}>
                <p>{t('Save')}</p>
              </Button>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          show={showAddItemAmandemen}
          onHide={() => setShowAddItemAmandemen(false)}
          backdrop='static'
          keyboard={false}
          centered
          scrollable
          size='xl'
        >
          <Modal.Header closeButton>
            <Modal.Title>{t('pilih')} Item</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Accordion>
              {fullNewOrder.map((data: any, _index: any) => (
                <>
                  {/* <label>{indexOrder.indexOf(_index)} {indexOrder[_index]}</label> */}
                  {allAddedID.indexOf(data.id) == -1 && (
                    <>
                      <Accordion.Item eventKey={data?.id}>
                        <Accordion.Header>
                          {data?.id} / {data?.produsen?.name} / {data?.product_name} /{' '}
                          {data?.incoterm1?.code}
                          {data?.incoterm2 == null
                            ? data?.incoterm2_id == null || data?.incoterm2_id == '0'
                              ? ''
                              : ' - ' + data?.incoterm2_id
                            : ' - ' + data?.incoterm2?.code}{' '}
                          /{' '}
                          {data?.provice
                            ? data.province?.region_name + ' - ' + data?.city?.city_name + ' /'
                            : ''}{' '}
                          {(i18next.language === 'en'
                            ? data.fixed_quantum?.toLocaleString('en', {maximumFractionDigits: 4})
                            : data.fixed_quantum?.toLocaleString('id', {
                                maximumFractionDigits: 4,
                              })) + (data.sector_id === 3 ? ' MT' : ' Ton')}
                        </Accordion.Header>
                        <Accordion.Body style={{backgroundColor: 'white'}}>
                          {sektorID == 1 && (
                            <Row>
                              <Col md={6}>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p>{t('pilih')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <input
                                      className='form-check-input'
                                      type='checkbox'
                                      id={'checkbox' + data.id}
                                      value={data.id}
                                      onClick={() => onclickCheckBox(data.id)}
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('kontrak-item')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control value={data.id} disabled size='sm' />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>Sales Org</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control value={data.produsen?.name} disabled size='sm' />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('kontrak-wilayah')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      value={data.province?.region_name}
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('kontrak-jenis')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      value={data.product_type_desc}
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='fs-6'>{t('Kuantum Pengajuan')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      value={
                                        i18next.language === 'en'
                                          ? data.request_quantum?.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            }) + ' Ton'
                                          : data.request_quantum?.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            }) + ' Ton'
                                      }
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className=''>{t('sub-order-kuantumD')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      value={
                                        i18next.language === 'en'
                                          ? data.fixed_quantum?.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            }) + ' Ton'
                                          : data.fixed_quantum?.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            }) + ' Ton'
                                      }
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('kontrak-spek')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      as='textarea'
                                      style={{height: '40px'}}
                                      value={data.product_spec}
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3 fs-6'>{t('segment')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      type='text'
                                      value={t(data.segment_name)}
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                              </Col>
                              <Col md={6}>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p>Status</p>
                                  </Col>
                                  <Col md={8}>
                                    <span className='d-block '>
                                      <span className='badge badge-light-primary'>
                                        {t(data.status_text)}
                                      </span>
                                    </span>
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('Sektor')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control value={t(data.sector?.name)} disabled size='sm' />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('kontrak-incoterm')}</p>
                                  </Col>
                                  <Col md={8}>
                                    {data.sector?.id == 2 ? (
                                      <>
                                        {data.incoterm2 == null ? (
                                          <Form.Control
                                            value={data.incoterm1?.code + ' - ' + data.incoterm2_id}
                                            disabled
                                            size='sm'
                                          />
                                        ) : (
                                          <Form.Control
                                            value={
                                              data.incoterm1?.code + ' - ' + data.incoterm2?.code
                                            }
                                            disabled
                                            size='sm'
                                          />
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        {data.incoterm2 == null ? (
                                          <Form.Control
                                            value={
                                              data.incoterm2_id == null || data.incoterm2_id == '0'
                                                ? data.incoterm1?.code
                                                : data.incoterm1?.code + '-' + data.incoterm2_id
                                            }
                                            disabled
                                            size='sm'
                                          />
                                        ) : (
                                          <Form.Control
                                            value={
                                              data.incoterm1?.code + ' - ' + data.incoterm2?.code
                                            }
                                            disabled
                                            size='sm'
                                          />
                                        )}
                                      </>
                                    )}
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('sub-order-kota')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      value={t(data.city?.city_name)}
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('kontrak-nama')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control value={data.product_name} disabled size='sm' />
                                  </Col>
                                </Row>
                                {data.is_formulated_price ? (
                                  <>
                                    <Row className='mb-4'>
                                      <Col sm={5}>
                                        <p className='fs-6 mt-4'>{t('Formulated Price')}</p>
                                      </Col>
                                      <Col sm={7} className='d-flex justify-content-start'>
                                        <Form.Check
                                          reverse
                                          name='formula_Price'
                                          className='mt-5 mb-2'
                                          type='checkbox'
                                          id='formula_Price'
                                          checked={data?.is_formulated_price}
                                        />
                                      </Col>
                                    </Row>
                                  </>
                                ) : (
                                  <>
                                    <Row className='mb-4'>
                                      <Col md={4}>
                                        <p className=''>{t('sub-order-hargaP')}/Ton</p>
                                      </Col>
                                      <Col md={8}>
                                        <Form.Control
                                          value={
                                            'Rp' + i18next.language === 'en'
                                              ? data.request_price?.toLocaleString('en', {
                                                  maximumFractionDigits: 4,
                                                })
                                              : data.request_price?.toLocaleString('id', {
                                                  maximumFractionDigits: 4,
                                                })
                                          }
                                          disabled
                                          size='sm'
                                        />
                                      </Col>
                                    </Row>
                                  </>
                                )}
                                <Row className='mb-3'>
                                  <Col md={4} className='d-flex align-items-center'>
                                    <p className='fs-6'>{t('sub-order-hargaD')}/Ton</p>
                                  </Col>
                                  <Col md={8}>
                                    {data.is_formulated_price ? (
                                      <CurrencyInput
                                        className='form-control form-control-sm'
                                        id={'hargap' + data.id}
                                        defaultValue={0}
                                        decimalSeparator={i18next.language === 'en' ? '.' : ','}
                                        groupSeparator={i18next.language === 'en' ? ',' : '.'}
                                        decimalsLimit={2}
                                        placeholder={t('Harga Pengajuan')}
                                      />
                                    ) : (
                                      data.price_usd != '0' ? <Form.Control
                                        aria-label='Default select example'
                                        size='sm'
                                        value={
                                          'USD ' + (i18next.language === 'en'
                                            ? data.price_usd?.toLocaleString('en', {
                                                maximumFractionDigits: 4,
                                              })
                                            : data.price_usd?.toLocaleString('id', {
                                                maximumFractionDigits: 4,
                                              }))
                                        }
                                        disabled
                                      /> : <Form.Control
                                        aria-label='Default select example'
                                        size='sm'
                                        value={
                                          'Rp ' + (i18next.language === 'en'
                                            ? data.fixed_price?.toLocaleString('en', {
                                                maximumFractionDigits: 4,
                                              })
                                            : data.fixed_price?.toLocaleString('id', {
                                                maximumFractionDigits: 4,
                                              }))
                                        }
                                        disabled
                                      />
                                    )}
                                  </Col>
                                </Row>

                                <Row className='mb-4'>
                                  <Col md={5}>
                                    <p className='mt-3 fs-6'>{t('termasuk-ppn')}</p>
                                  </Col>
                                  <Col md={7} className='d-flex justify-content-start'>
                                    <Form.Check
                                      reverse
                                      name='ppn'
                                      className='mt-3 mb-2'
                                      type='checkbox'
                                      id='ckbox-ppn'
                                      checked={data.include_ppn}
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('sub-order-catatan')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      as='textarea'
                                      style={{height: '40px'}}
                                      value={data.notes}
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          )}

                          {sektorID == 3 && (
                            <Row>
                              <Col md={6}>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p>{t('pilih')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <input
                                      className='form-check-input'
                                      type='checkbox'
                                      id={'checkbox' + data.id}
                                      value={data.id}
                                      onClick={() => onclickCheckBox(data.id)}
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('kontrak-item')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control value={data.id} disabled size='sm' />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>Sales Org</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control value={data.produsen?.name} disabled size='sm' />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('kontrak-wilayah')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      value={data.province?.region_name}
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('kontrak-jenis')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      value={data.product_type_desc}
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='fs-6'>{t('Kuantum Pengajuan')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      value={
                                        i18next.language === 'en'
                                          ? data.request_quantum?.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            }) + ' MT'
                                          : data.request_quantum?.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            }) + ' MT'
                                      }
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className=''>{t('sub-order-kuantumD')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      value={
                                        i18next.language === 'en'
                                          ? data.fixed_quantum?.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            }) + ' MT'
                                          : data.fixed_quantum?.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            }) + ' MT'
                                      }
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('kontrak-spek')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      as='textarea'
                                      style={{height: '40px'}}
                                      value={data.product_spec}
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                              </Col>
                              <Col md={6}>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p>Status</p>
                                  </Col>
                                  <Col md={8}>
                                    <span className='d-block '>
                                      <span className='badge badge-light-primary'>
                                        {t(data.status_text)}
                                      </span>
                                    </span>
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('Sektor')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control value={t(data.sector?.name)} disabled size='sm' />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('kontrak-incoterm')}</p>
                                  </Col>
                                  <Col md={8}>
                                    {data.sector?.id == 2 ? (
                                      <>
                                        {data.incoterm2 == null ? (
                                          <Form.Control
                                            value={data.incoterm1?.code + ' - ' + data.incoterm2_id}
                                            disabled
                                            size='sm'
                                          />
                                        ) : (
                                          <Form.Control
                                            value={
                                              data.incoterm1?.code + ' - ' + data.incoterm2?.code
                                            }
                                            disabled
                                            size='sm'
                                          />
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        {data.incoterm2 == null ? (
                                          <Form.Control
                                            value={
                                              data.incoterm2_id == null || data.incoterm2_id == '0'
                                                ? data.incoterm1?.code
                                                : data.incoterm1?.code + '-' + data.incoterm2_id
                                            }
                                            disabled
                                            size='sm'
                                          />
                                        ) : (
                                          <Form.Control
                                            value={
                                              data.incoterm1?.code + ' - ' + data.incoterm2?.code
                                            }
                                            disabled
                                            size='sm'
                                          />
                                        )}
                                      </>
                                    )}
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('sub-order-kota')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      value={t(data.city?.city_name)}
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('kontrak-nama')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control value={data.product_name} disabled size='sm' />
                                  </Col>
                                </Row>
                                {data.is_formulated_price ? (
                                  <>
                                    <Row className='mb-4'>
                                      <Col sm={5}>
                                        <p className='fs-6 mt-4'>{t('Formulated Price')}</p>
                                      </Col>
                                      <Col sm={7} className='d-flex justify-content-start'>
                                        <Form.Check
                                          reverse
                                          name='formula_Price'
                                          className='mt-5 mb-2'
                                          type='checkbox'
                                          id='formula_Price'
                                          checked={data?.is_formulated_price}
                                        />
                                      </Col>
                                    </Row>
                                  </>
                                ) : (
                                  <>
                                    <Row className='mb-4'>
                                      <Col md={4}>
                                        <p className=''>{t('sub-order-hargaP')}/MT</p>
                                      </Col>
                                      <Col md={8}>
                                        <Form.Control
                                          value={'USD' + PriceFormater(data.request_price)}
                                          disabled
                                          size='sm'
                                        />
                                      </Col>
                                    </Row>
                                  </>
                                )}
                                <Row className='mb-3'>
                                  <Col md={4} className='d-flex align-items-center'>
                                    <p className='fs-6'>{t('sub-order-hargaD')}/MT</p>
                                  </Col>
                                  <Col md={8}>
                                    {data.is_formulated_price ? (
                                      <CurrencyInput
                                        className='form-control form-control-sm'
                                        id={'hargap' + data.id}
                                        defaultValue={0}
                                        decimalSeparator={i18next.language === 'en' ? '.' : ','}
                                        groupSeparator={i18next.language === 'en' ? ',' : '.'}
                                        decimalsLimit={2}
                                        placeholder={t('Harga Pengajuan')}
                                      />
                                    ) : (
                                      <Form.Control
                                        aria-label='Default select example'
                                        size='sm'
                                        value={'USD' + PriceFormater(data.fixed_price)}
                                        disabled
                                      />
                                    )}
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3'>{t('sub-order-catatan')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      as='textarea'
                                      style={{height: '40px'}}
                                      value={data.notes}
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          )}
                        </Accordion.Body>
                      </Accordion.Item>
                    </>
                  )}
                </>
              ))}
            </Accordion>
            <div className='d-flex justify-content-end mt-5'>
              <Button className='justify-content-end' onClick={() => addInOrder2()}>
                {t('Save')}
              </Button>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          show={showLetter}
          onHide={() => setShowLetter(false)}
          size='xl'
          backdrop='static'
          keyboard={false}
          scrollable
        >
          <Modal.Header closeButton>
            <Modal.Title>{t('preview')}</Modal.Title>
          </Modal.Header>
          <Modal.Body key={letterData}>
            <ViewLetter data={letterData} type='sip' />
          </Modal.Body>
        </Modal>

        <SIPHistories
          show={showModalHistory}
          id={params.id}
          onCloseModal={() => setShowModalHistory(false)}
        />

        {/* <PDFPreviewModal show={showPDFPreview} onHide={() => setShowPDFPreview(false)} /> */}
      </div>
    </>
  )
}

export {SIPEdit}
